;(() => {
	var e = {
			272: (e, t, i) => {
				"use strict"
				i.d(t, { gM: () => s, LE: () => n })
				i(280)
				;((window.MinimogEvents =
					window.MinimogEvents ||
					new (class {
						constructor() {
							this.events = {}
						}
						get evts() {
							return Object.keys(this.events)
						}
						subscribe(e, t) {
							return (
								(this.events[e] = this.events[e] || []),
								this.events[e].push(t),
								() => this.unSubscribe(e, t)
							)
						}
						unSubscribe(e, t) {
							const i = this.events[e]
							if (i && Array.isArray(i))
								for (let e = 0; e < i.length; e++)
									if (i[e] === t) {
										i.splice(e, 1)
										break
									}
						}
						emit(e, ...t) {
							;(this.events[e] || []).forEach((e) => {
								e(...t)
							})
						}
					})()),
					(window._ThemeEvent = window.MinimogEvents),
					(window.MinimogLibs.loadjs = __loadjs))
				window.MinimogEvents
				const n = window.MinimogTheme || {},
					s = (window.MinimogSettings, window.MinimogStrings, window.MinimogLibs || {})
			},
			280: () => {
				__loadjs = (function () {
					var e = function () {},
						t = {},
						i = {},
						n = {}
					function s(e, t) {
						if (e) {
							var s = n[e]
							if (((i[e] = t), s)) for (; s.length; ) (s[0](e, t), s.splice(0, 1))
						}
					}
					function r(t, i) {
						;(t.call && (t = { success: t }), i.length ? (t.error || e)(i) : (t.success || e)(t))
					}
					function a(t, i, n, s) {
						var r,
							o,
							l = document,
							d = n.async,
							c = (n.numRetries || 0) + 1,
							u = n.before || e,
							p = t.replace(/[\?|#].*$/, ""),
							h = t.replace(/^(css|img)!/, "")
						;((s = s || 0),
							/(^css!|\.css$)/.test(p)
								? (((o = l.createElement("link")).rel = "stylesheet"),
									(o.href = h),
									(r = "hideFocus" in o) &&
										o.relList &&
										((r = 0), (o.rel = "preload"), (o.as = "style")))
								: /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(p)
									? ((o = l.createElement("img")).src = h)
									: (((o = l.createElement("script")).src = t), (o.async = void 0 === d || d)),
							!(o.onload =
								o.onerror =
								o.onbeforeload =
									function (e) {
										var l = e.type[0]
										if (r)
											try {
												o.sheet.cssText.length || (l = "e")
											} catch (e) {
												18 != e.code && (l = "e")
											}
										if ("e" == l) {
											if ((s += 1) < c) return a(t, i, n, s)
										} else if ("preload" == o.rel && "style" == o.as) return (o.rel = "stylesheet")
										i(t, l, e.defaultPrevented)
									}) !== u(t, o) && l.head.appendChild(o))
					}
					function o(e, i, n) {
						var o, l
						if ((i && i.trim && (o = i), (l = (o ? n : i) || {}), o)) {
							if (o in t) throw "LoadJS"
							t[o] = !0
						}
						function d(t, i) {
							!(function (e, t, i) {
								var n,
									s,
									r = (e = e.push ? e : [e]).length,
									o = r,
									l = []
								for (
									n = function (e, i, n) {
										if (("e" == i && l.push(e), "b" == i)) {
											if (!n) return
											l.push(e)
										}
										--r || t(l)
									},
										s = 0;
									s < o;
									s++
								)
									a(e[s], n, i)
							})(
								e,
								function (e) {
									;(r(l, e), t && r({ success: t, error: i }, e), s(o, e))
								},
								l,
							)
						}
						if (l.returnPromise) return new Promise(d)
						d()
					}
					return (
						(o.ready = function (e, t) {
							return (
								(function (e, t) {
									e = e.push ? e : [e]
									var s,
										r,
										a,
										o = [],
										l = e.length,
										d = l
									for (
										s = function (e, i) {
											;(i.length && o.push(e), --d || t(o))
										};
										l--;
									)
										((r = e[l]), (a = i[r]) ? s(r, a) : (n[r] = n[r] || []).push(s))
								})(e, function (e) {
									r(t, e)
								}),
								o
							)
						}),
						(o.done = function (e) {
							s(e, [])
						}),
						(o.reset = function () {
							;((t = {}), (i = {}), (n = {}))
						}),
						(o.isDefined = function (e) {
							return e in t
						}),
						o
					)
				})()
			},
			295: (e, t, i) => {
				"use strict"
				i.d(t, { Z: () => n })
				i(422)
				const n = new (class {
					constructor() {
						return ((this.component = this.component.bind(this)), this.component)
					}
					component(e, t, ...i) {
						if ("function" == typeof e) return e({ ...t, children: i })
						;(i && (i = i.filter((e) => null !== e)),
							t && (t.class && (t.className = t.class), delete t.children))
						let n =
							"fragment" !== e
								? (function (e, t) {
										t = t || {}
										let i = document.createElement(e)
										try {
											i = Object.assign(i, t)
										} catch {
											const e = Object.keys(t)
											for (let n = 0; n < e.length; n++)
												"dataSet" !== t[n] && i.setAttribute(e[n], t[e[n]])
										}
										return i
									})(e, t)
								: document.createDocumentFragment()
						if (-1 !== ["svg", "path", "rect", "text", "circle", "g"].indexOf(e)) {
							n = document.createElementNS("http://www.w3.org/2000/svg", e)
							for (const e in t) {
								const i = "className" === e ? "class" : e
								n.setAttribute(i, t[e])
							}
						}
						for (const e of i) Array.isArray(e) ? n.append(...e) : n.append(e)
						if (null != t && t.dataSet)
							for (const e in t.dataSet)
								Object.prototype.hasOwnProperty.call(t.dataSet, e) && (n.dataset[e] = t.dataSet[e])
						return (
							t &&
								!window.__aleartedJSXData &&
								Object.keys(t).find((e) => e.match(/^data-/)) &&
								(alert(
									"Do not use data-* in your JSX component! Use dataSet instead!! - Check the console.trace for more info",
								),
								(window.__aleartedJSXData = !0)),
							null != t && t.ref && ("function" == typeof t.ref ? t.ref(n) : (t.ref = n)),
							null != t &&
								t.on &&
								Object.entries(t.on).forEach(([e, t]) => {
									n.addEventListener(e, t)
								}),
							null != t &&
								t.style &&
								Object.entries(t.style).forEach(([e, t]) => {
									n.style.setProperty(e, t)
								}),
							n
						)
					}
				})()
			},
			367: function (e) {
				e.exports = (() => {
					"use strict"
					var e = {
							d: (t, i) => {
								for (var n in i)
									e.o(i, n) &&
										!e.o(t, n) &&
										Object.defineProperty(t, n, { enumerable: !0, get: i[n] })
							},
							o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
							r: (e) => {
								;("undefined" != typeof Symbol &&
									Symbol.toStringTag &&
									Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
									Object.defineProperty(e, "__esModule", { value: !0 }))
							},
						},
						t = {}
					function i(e, t) {
						for (var i = 0; i < t.length; i++) {
							var n = t[i]
							;((n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								"value" in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n))
						}
					}
					function n(e, t, n) {
						return (
							t && i(e.prototype, t),
							n && i(e, n),
							Object.defineProperty(e, "prototype", { writable: !1 }),
							e
						)
					}
					function s(e, t) {
						if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
					}
					function r(e, t, i) {
						return (
							t in e
								? Object.defineProperty(e, t, {
										value: i,
										enumerable: !0,
										configurable: !0,
										writable: !0,
									})
								: (e[t] = i),
							e
						)
					}
					;(e.r(t), e.d(t, { default: () => o }))
					var a = {
							overlay: null,
							thickness: "3px",
							color: "gray",
							startDuration: 1e3,
							finishDuration: 300,
						},
						o = n(function e() {
							var t = this,
								i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.body,
								n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
							;(s(this, e),
								r(this, "setLoadingData", function () {
									var e = t.target,
										i = t.options,
										n = i.startDuration,
										s = i.finishDuration,
										r = i.thickness,
										a = i.color
									;(e.style.setProperty("--al-thickness", " ".concat(r)),
										e.style.setProperty("--al-color", " ".concat(a)),
										e.style.setProperty("--al-start-duration", " ".concat(n, "ms")),
										e.style.setProperty("--al-finish-duration", " ".concat(s, "ms")))
								}),
								r(this, "start", function () {
									;(t.target.classList.add("al-loading-bar", "start", "loading"),
										t.overlay && t.overlay.classList.add("al-loading-overlay", "overlay-show"))
								}),
								r(this, "finish", function () {
									var e =
											arguments.length > 0 && void 0 !== arguments[0]
												? arguments[0]
												: function () {},
										i = t.target,
										n = t.overlay,
										s = t.cleanUp,
										r = t.options.finishDuration,
										a = window.getComputedStyle(i, ":before").width
									;(i.style.setProperty("--al-end-width", a),
										i.classList.add("loaded"),
										i.classList.remove("loading"),
										window.requestAnimationFrame(function () {
											;(i.classList.add("finished"),
												t.overlay && n.classList.remove("overlay-show"))
										}),
										setTimeout(s, 2 * r),
										setTimeout(e, r))
								}),
								r(this, "cleanUp", function () {
									;(t.target.classList.remove("al-loading-bar", "start", "loaded", "finished"),
										t.overlay && t.overlay.classList.remove("al-loading-overlay"))
								}),
								(this.options = Object.assign({}, a, n)),
								(this.target = i),
								(this.overlay = this.options.overlay),
								this.setLoadingData())
						})
					return t
				})()
			},
			422: () => {
				!(function () {
					function e() {
						var e = Array.prototype.slice.call(arguments),
							t = document.createDocumentFragment()
						;(e.forEach(function (e) {
							var i = e instanceof Node
							t.appendChild(i ? e : document.createTextNode(String(e)))
						}),
							this.appendChild(t))
					}
					;[Element.prototype, Document.prototype, DocumentFragment.prototype].forEach(
						function (t) {
							t.hasOwnProperty("append") ||
								Object.defineProperty(t, "append", {
									configurable: !0,
									enumerable: !0,
									writable: !0,
									value: e,
								})
						},
					)
				})()
			},
			643: (e) => {
				var t = "complete",
					i = "canceled"
				function n(e, t, i) {
					;(Math.max(0, t),
						Math.max(0, i),
						e.self === e ? e.scrollTo(t, i) : ((e.scrollLeft = t), (e.scrollTop = i)))
				}
				function s(e) {
					var i = e._scrollSettings
					if (i) {
						var r = i.maxSynchronousAlignments,
							a = (function (e, t) {
								var i,
									n,
									s,
									r,
									a,
									o,
									l,
									d = e.align,
									c = e.target.getBoundingClientRect(),
									u = d && null != d.left ? d.left : 0.5,
									p = d && null != d.top ? d.top : 0.5,
									h = d && null != d.leftOffset ? d.leftOffset : 0,
									f = d && null != d.topOffset ? d.topOffset : 0,
									v = u,
									m = p
								if (e.isWindow(t))
									((o = Math.min(c.width, t.innerWidth)),
										(l = Math.min(c.height, t.innerHeight)),
										(n = c.left + t.pageXOffset - t.innerWidth * v + o * v),
										(s = c.top + t.pageYOffset - t.innerHeight * m + l * m),
										(n -= h),
										(s -= f),
										(n = e.align.lockX ? t.pageXOffset : n),
										(s = e.align.lockY ? t.pageYOffset : s),
										(r = n - t.pageXOffset),
										(a = s - t.pageYOffset))
								else {
									;((o = c.width), (l = c.height), (i = t.getBoundingClientRect()))
									var g = c.left - (i.left - t.scrollLeft),
										y = c.top - (i.top - t.scrollTop)
									;((n = g + o * v - t.clientWidth * v),
										(s = y + l * m - t.clientHeight * m),
										(n -= h),
										(s -= f),
										(n = Math.max(Math.min(n, t.scrollWidth - t.clientWidth), 0)),
										(s = Math.max(Math.min(s, t.scrollHeight - t.clientHeight), 0)),
										(n = e.align.lockX ? t.scrollLeft : n),
										(s = e.align.lockY ? t.scrollTop : s),
										(r = n - t.scrollLeft),
										(a = s - t.scrollTop))
								}
								return { x: n, y: s, differenceX: r, differenceY: a }
							})(i, e),
							o = Date.now() - i.startTime,
							l = Math.min((1 / i.time) * o, 1)
						if (i.endIterations >= r) return (n(e, a.x, a.y), (e._scrollSettings = null), i.end(t))
						var d = 1 - i.ease(l)
						if ((n(e, a.x - a.differenceX * d, a.y - a.differenceY * d), o >= i.time))
							return (i.endIterations++, i.scrollAncestor && s(i.scrollAncestor), void s(e))
						!(function (e) {
							if ("requestAnimationFrame" in window) return window.requestAnimationFrame(e)
							setTimeout(e, 16)
						})(s.bind(null, e))
					}
				}
				function r(e) {
					return e.self === e
				}
				function a(e) {
					return (
						"pageXOffset" in e ||
						((e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth) &&
							"hidden" !== getComputedStyle(e).overflow)
					)
				}
				function o() {
					return !0
				}
				function l(e) {
					if (e.assignedSlot) return l(e.assignedSlot)
					if (e.parentElement)
						return "body" === e.parentElement.tagName.toLowerCase()
							? e.parentElement.ownerDocument.defaultView ||
									e.parentElement.ownerDocument.ownerWindow
							: e.parentElement
					if (e.getRootNode) {
						var t = e.getRootNode()
						if (11 === t.nodeType) return t.host
					}
				}
				e.exports = function (e, n, d) {
					if (e) {
						;("function" == typeof n && ((d = n), (n = null)),
							n || (n = {}),
							(n.time = isNaN(n.time) ? 1e3 : n.time),
							(n.ease =
								n.ease ||
								function (e) {
									return 1 - Math.pow(1 - e, e / 2)
								}),
							(n.align = n.align || {}))
						var c = l(e),
							u = 1,
							p = n.validTarget || o,
							h = n.isScrollable
						n.debug
						for (var f = []; c; )
							if ((n.debug, p(c, u) && (h ? h(c, a) : a(c)) && (u++, f.push(c)), !(c = l(c)))) {
								v(t)
								break
							}
						return f.reduce(
							(t, a, o) =>
								(function (e, t, n, a, o) {
									var l,
										d = !t._scrollSettings,
										c = t._scrollSettings,
										u = Date.now(),
										p = { passive: !0 }
									function h(e) {
										;((t._scrollSettings = null),
											t.parentElement &&
												t.parentElement._scrollSettings &&
												t.parentElement._scrollSettings.end(e),
											n.debug,
											o(e),
											l &&
												(t.removeEventListener("touchstart", l, p),
												t.removeEventListener("wheel", l, p)))
									}
									c && c.end(i)
									var f = n.maxSynchronousAlignments
									return (
										null == f && (f = 3),
										(t._scrollSettings = {
											startTime: u,
											endIterations: 0,
											target: e,
											time: n.time,
											ease: n.ease,
											align: n.align,
											isWindow: n.isWindow || r,
											maxSynchronousAlignments: f,
											end: h,
											scrollAncestor: a,
										}),
										("cancellable" in n && !n.cancellable) ||
											((l = h.bind(null, i)),
											t.addEventListener("touchstart", l, p),
											t.addEventListener("wheel", l, p)),
										d && s(t),
										l
									)
								})(e, a, n, f[o + 1], v),
							null,
						)
					}
					function v(e) {
						--u || (d && d(e))
					}
				}
			},
			924: (e, t, i) => {
				"use strict"
				i.r(t)
			},
		},
		t = {}
	function i(n) {
		var s = t[n]
		if (void 0 !== s) return s.exports
		var r = (t[n] = { exports: {} })
		return (e[n].call(r.exports, r, r.exports, i), r.exports)
	}
	;((i.n = (e) => {
		var t = e && e.__esModule ? () => e.default : () => e
		return (i.d(t, { a: t }), t)
	}),
		(i.d = (e, t) => {
			for (var n in t)
				i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] })
		}),
		(i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
		(i.r = (e) => {
			;("undefined" != typeof Symbol &&
				Symbol.toStringTag &&
				Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
				Object.defineProperty(e, "__esModule", { value: !0 }))
		}),
		(() => {
			"use strict"
			function e(e) {
				return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
			}
			function t(i, n) {
				;(void 0 === i && (i = {}),
					void 0 === n && (n = {}),
					Object.keys(n).forEach(function (s) {
						void 0 === i[s]
							? (i[s] = n[s])
							: e(n[s]) && e(i[s]) && Object.keys(n[s]).length > 0 && t(i[s], n[s])
					}))
			}
			var n = {
				body: {},
				addEventListener: function () {},
				removeEventListener: function () {},
				activeElement: { blur: function () {}, nodeName: "" },
				querySelector: function () {
					return null
				},
				querySelectorAll: function () {
					return []
				},
				getElementById: function () {
					return null
				},
				createEvent: function () {
					return { initEvent: function () {} }
				},
				createElement: function () {
					return {
						children: [],
						childNodes: [],
						style: {},
						setAttribute: function () {},
						getElementsByTagName: function () {
							return []
						},
					}
				},
				createElementNS: function () {
					return {}
				},
				importNode: function () {
					return null
				},
				location: {
					hash: "",
					host: "",
					hostname: "",
					href: "",
					origin: "",
					pathname: "",
					protocol: "",
					search: "",
				},
			}
			function s() {
				var e = "undefined" != typeof document ? document : {}
				return (t(e, n), e)
			}
			var r = {
				document: n,
				navigator: { userAgent: "" },
				location: {
					hash: "",
					host: "",
					hostname: "",
					href: "",
					origin: "",
					pathname: "",
					protocol: "",
					search: "",
				},
				history: {
					replaceState: function () {},
					pushState: function () {},
					go: function () {},
					back: function () {},
				},
				CustomEvent: function () {
					return this
				},
				addEventListener: function () {},
				removeEventListener: function () {},
				getComputedStyle: function () {
					return {
						getPropertyValue: function () {
							return ""
						},
					}
				},
				Image: function () {},
				Date: function () {},
				screen: {},
				setTimeout: function () {},
				clearTimeout: function () {},
				matchMedia: function () {
					return {}
				},
				requestAnimationFrame: function (e) {
					return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)
				},
				cancelAnimationFrame: function (e) {
					"undefined" != typeof setTimeout && clearTimeout(e)
				},
			}
			function a() {
				var e = "undefined" != typeof window ? window : {}
				return (t(e, r), e)
			}
			function o(e) {
				return (
					(o = Object.setPrototypeOf
						? Object.getPrototypeOf
						: function (e) {
								return e.__proto__ || Object.getPrototypeOf(e)
							}),
					o(e)
				)
			}
			function l(e, t) {
				return (
					(l =
						Object.setPrototypeOf ||
						function (e, t) {
							return ((e.__proto__ = t), e)
						}),
					l(e, t)
				)
			}
			function d(e, t, i) {
				return (
					(d = (function () {
						if ("undefined" == typeof Reflect || !Reflect.construct) return !1
						if (Reflect.construct.sham) return !1
						if ("function" == typeof Proxy) return !0
						try {
							return (Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0)
						} catch (e) {
							return !1
						}
					})()
						? Reflect.construct
						: function (e, t, i) {
								var n = [null]
								n.push.apply(n, t)
								var s = new (Function.bind.apply(e, n))()
								return (i && l(s, i.prototype), s)
							}),
					d.apply(null, arguments)
				)
			}
			function c(e) {
				var t = "function" == typeof Map ? new Map() : void 0
				return (
					(c = function (e) {
						if (null === e || ((i = e), -1 === Function.toString.call(i).indexOf("[native code]")))
							return e
						var i
						if ("function" != typeof e)
							throw new TypeError("Super expression must either be null or a function")
						if (void 0 !== t) {
							if (t.has(e)) return t.get(e)
							t.set(e, n)
						}
						function n() {
							return d(e, arguments, o(this).constructor)
						}
						return (
							(n.prototype = Object.create(e.prototype, {
								constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
							})),
							l(n, e)
						)
					}),
					c(e)
				)
			}
			var u = (function (e) {
				var t, i
				function n(t) {
					var i, n, s
					return (
						(i = e.call.apply(e, [this].concat(t)) || this),
						(n = (function (e) {
							if (void 0 === e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called",
								)
							return e
						})(i)),
						(s = n.__proto__),
						Object.defineProperty(n, "__proto__", {
							get: function () {
								return s
							},
							set: function (e) {
								s.__proto__ = e
							},
						}),
						i
					)
				}
				return (
					(i = e),
					((t = n).prototype = Object.create(i.prototype)),
					(t.prototype.constructor = t),
					(t.__proto__ = i),
					n
				)
			})(c(Array))
			function p(e) {
				void 0 === e && (e = [])
				var t = []
				return (
					e.forEach(function (e) {
						Array.isArray(e) ? t.push.apply(t, p(e)) : t.push(e)
					}),
					t
				)
			}
			function h(e, t) {
				return Array.prototype.filter.call(e, t)
			}
			function f(e, t) {
				var i = a(),
					n = s(),
					r = []
				if (!t && e instanceof u) return e
				if (!e) return new u(r)
				if ("string" == typeof e) {
					var o = e.trim()
					if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
						var l = "div"
						;(0 === o.indexOf("<li") && (l = "ul"),
							0 === o.indexOf("<tr") && (l = "tbody"),
							(0 !== o.indexOf("<td") && 0 !== o.indexOf("<th")) || (l = "tr"),
							0 === o.indexOf("<tbody") && (l = "table"),
							0 === o.indexOf("<option") && (l = "select"))
						var d = n.createElement(l)
						d.innerHTML = o
						for (var c = 0; c < d.childNodes.length; c += 1) r.push(d.childNodes[c])
					} else
						r = (function (e, t) {
							if ("string" != typeof e) return [e]
							for (var i = [], n = t.querySelectorAll(e), s = 0; s < n.length; s += 1) i.push(n[s])
							return i
						})(e.trim(), t || n)
				} else if (e.nodeType || e === i || e === n) r.push(e)
				else if (Array.isArray(e)) {
					if (e instanceof u) return e
					r = e
				}
				return new u(
					(function (e) {
						for (var t = [], i = 0; i < e.length; i += 1) -1 === t.indexOf(e[i]) && t.push(e[i])
						return t
					})(r),
				)
			}
			f.fn = u.prototype
			var v = "resize scroll".split(" ")
			function m(e) {
				return function () {
					for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++) i[n] = arguments[n]
					if (void 0 === i[0]) {
						for (var s = 0; s < this.length; s += 1)
							v.indexOf(e) < 0 && (e in this[s] ? this[s][e]() : f(this[s]).trigger(e))
						return this
					}
					return this.on.apply(this, [e].concat(i))
				}
			}
			;(m("click"),
				m("blur"),
				m("focus"),
				m("focusin"),
				m("focusout"),
				m("keyup"),
				m("keydown"),
				m("keypress"),
				m("submit"),
				m("change"),
				m("mousedown"),
				m("mousemove"),
				m("mouseup"),
				m("mouseenter"),
				m("mouseleave"),
				m("mouseout"),
				m("mouseover"),
				m("touchstart"),
				m("touchend"),
				m("touchmove"),
				m("resize"),
				m("scroll"))
			var g = {
				addClass: function () {
					for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i]
					var n = p(
						t.map(function (e) {
							return e.split(" ")
						}),
					)
					return (
						this.forEach(function (e) {
							var t
							;(t = e.classList).add.apply(t, n)
						}),
						this
					)
				},
				removeClass: function () {
					for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i]
					var n = p(
						t.map(function (e) {
							return e.split(" ")
						}),
					)
					return (
						this.forEach(function (e) {
							var t
							;(t = e.classList).remove.apply(t, n)
						}),
						this
					)
				},
				hasClass: function () {
					for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i]
					var n = p(
						t.map(function (e) {
							return e.split(" ")
						}),
					)
					return (
						h(this, function (e) {
							return (
								n.filter(function (t) {
									return e.classList.contains(t)
								}).length > 0
							)
						}).length > 0
					)
				},
				toggleClass: function () {
					for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i]
					var n = p(
						t.map(function (e) {
							return e.split(" ")
						}),
					)
					this.forEach(function (e) {
						n.forEach(function (t) {
							e.classList.toggle(t)
						})
					})
				},
				attr: function (e, t) {
					if (1 === arguments.length && "string" == typeof e)
						return this[0] ? this[0].getAttribute(e) : void 0
					for (var i = 0; i < this.length; i += 1)
						if (2 === arguments.length) this[i].setAttribute(e, t)
						else for (var n in e) ((this[i][n] = e[n]), this[i].setAttribute(n, e[n]))
					return this
				},
				removeAttr: function (e) {
					for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e)
					return this
				},
				transform: function (e) {
					for (var t = 0; t < this.length; t += 1) this[t].style.transform = e
					return this
				},
				transition: function (e) {
					for (var t = 0; t < this.length; t += 1)
						this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e
					return this
				},
				on: function () {
					for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i]
					var n = t[0],
						s = t[1],
						r = t[2],
						a = t[3]
					function o(e) {
						var t = e.target
						if (t) {
							var i = e.target.dom7EventData || []
							if ((i.indexOf(e) < 0 && i.unshift(e), f(t).is(s))) r.apply(t, i)
							else
								for (var n = f(t).parents(), a = 0; a < n.length; a += 1)
									f(n[a]).is(s) && r.apply(n[a], i)
						}
					}
					function l(e) {
						var t = (e && e.target && e.target.dom7EventData) || []
						;(t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t))
					}
					;("function" == typeof t[1] && ((n = t[0]), (r = t[1]), (a = t[2]), (s = void 0)),
						a || (a = !1))
					for (var d, c = n.split(" "), u = 0; u < this.length; u += 1) {
						var p = this[u]
						if (s)
							for (d = 0; d < c.length; d += 1) {
								var h = c[d]
								;(p.dom7LiveListeners || (p.dom7LiveListeners = {}),
									p.dom7LiveListeners[h] || (p.dom7LiveListeners[h] = []),
									p.dom7LiveListeners[h].push({ listener: r, proxyListener: o }),
									p.addEventListener(h, o, a))
							}
						else
							for (d = 0; d < c.length; d += 1) {
								var v = c[d]
								;(p.dom7Listeners || (p.dom7Listeners = {}),
									p.dom7Listeners[v] || (p.dom7Listeners[v] = []),
									p.dom7Listeners[v].push({ listener: r, proxyListener: l }),
									p.addEventListener(v, l, a))
							}
					}
					return this
				},
				off: function () {
					for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i]
					var n = t[0],
						s = t[1],
						r = t[2],
						a = t[3]
					;("function" == typeof t[1] && ((n = t[0]), (r = t[1]), (a = t[2]), (s = void 0)),
						a || (a = !1))
					for (var o = n.split(" "), l = 0; l < o.length; l += 1)
						for (var d = o[l], c = 0; c < this.length; c += 1) {
							var u = this[c],
								p = void 0
							if (
								(!s && u.dom7Listeners
									? (p = u.dom7Listeners[d])
									: s && u.dom7LiveListeners && (p = u.dom7LiveListeners[d]),
								p && p.length)
							)
								for (var h = p.length - 1; h >= 0; h -= 1) {
									var f = p[h]
									;(r && f.listener === r) ||
									(r && f.listener && f.listener.dom7proxy && f.listener.dom7proxy === r)
										? (u.removeEventListener(d, f.proxyListener, a), p.splice(h, 1))
										: r || (u.removeEventListener(d, f.proxyListener, a), p.splice(h, 1))
								}
						}
					return this
				},
				trigger: function () {
					for (var e = a(), t = arguments.length, i = new Array(t), n = 0; n < t; n++)
						i[n] = arguments[n]
					for (var s = i[0].split(" "), r = i[1], o = 0; o < s.length; o += 1)
						for (var l = s[o], d = 0; d < this.length; d += 1) {
							var c = this[d]
							if (e.CustomEvent) {
								var u = new e.CustomEvent(l, { detail: r, bubbles: !0, cancelable: !0 })
								;((c.dom7EventData = i.filter(function (e, t) {
									return t > 0
								})),
									c.dispatchEvent(u),
									(c.dom7EventData = []),
									delete c.dom7EventData)
							}
						}
					return this
				},
				transitionEnd: function (e) {
					var t = this
					return (
						e &&
							t.on("transitionend", function i(n) {
								n.target === this && (e.call(this, n), t.off("transitionend", i))
							}),
						this
					)
				},
				outerWidth: function (e) {
					if (this.length > 0) {
						if (e) {
							var t = this.styles()
							return (
								this[0].offsetWidth +
								parseFloat(t.getPropertyValue("margin-right")) +
								parseFloat(t.getPropertyValue("margin-left"))
							)
						}
						return this[0].offsetWidth
					}
					return null
				},
				outerHeight: function (e) {
					if (this.length > 0) {
						if (e) {
							var t = this.styles()
							return (
								this[0].offsetHeight +
								parseFloat(t.getPropertyValue("margin-top")) +
								parseFloat(t.getPropertyValue("margin-bottom"))
							)
						}
						return this[0].offsetHeight
					}
					return null
				},
				styles: function () {
					var e = a()
					return this[0] ? e.getComputedStyle(this[0], null) : {}
				},
				offset: function () {
					if (this.length > 0) {
						var e = a(),
							t = s(),
							i = this[0],
							n = i.getBoundingClientRect(),
							r = t.body,
							o = i.clientTop || r.clientTop || 0,
							l = i.clientLeft || r.clientLeft || 0,
							d = i === e ? e.scrollY : i.scrollTop,
							c = i === e ? e.scrollX : i.scrollLeft
						return { top: n.top + d - o, left: n.left + c - l }
					}
					return null
				},
				css: function (e, t) {
					var i,
						n = a()
					if (1 === arguments.length) {
						if ("string" != typeof e) {
							for (i = 0; i < this.length; i += 1) for (var s in e) this[i].style[s] = e[s]
							return this
						}
						if (this[0]) return n.getComputedStyle(this[0], null).getPropertyValue(e)
					}
					if (2 === arguments.length && "string" == typeof e) {
						for (i = 0; i < this.length; i += 1) this[i].style[e] = t
						return this
					}
					return this
				},
				each: function (e) {
					return e
						? (this.forEach(function (t, i) {
								e.apply(t, [t, i])
							}),
							this)
						: this
				},
				html: function (e) {
					if (void 0 === e) return this[0] ? this[0].innerHTML : null
					for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e
					return this
				},
				text: function (e) {
					if (void 0 === e) return this[0] ? this[0].textContent.trim() : null
					for (var t = 0; t < this.length; t += 1) this[t].textContent = e
					return this
				},
				is: function (e) {
					var t,
						i,
						n = a(),
						r = s(),
						o = this[0]
					if (!o || void 0 === e) return !1
					if ("string" == typeof e) {
						if (o.matches) return o.matches(e)
						if (o.webkitMatchesSelector) return o.webkitMatchesSelector(e)
						if (o.msMatchesSelector) return o.msMatchesSelector(e)
						for (t = f(e), i = 0; i < t.length; i += 1) if (t[i] === o) return !0
						return !1
					}
					if (e === r) return o === r
					if (e === n) return o === n
					if (e.nodeType || e instanceof u) {
						for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1) if (t[i] === o) return !0
						return !1
					}
					return !1
				},
				index: function () {
					var e,
						t = this[0]
					if (t) {
						for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1)
						return e
					}
				},
				eq: function (e) {
					if (void 0 === e) return this
					var t = this.length
					if (e > t - 1) return f([])
					if (e < 0) {
						var i = t + e
						return f(i < 0 ? [] : [this[i]])
					}
					return f([this[e]])
				},
				append: function () {
					for (var e, t = s(), i = 0; i < arguments.length; i += 1) {
						e = i < 0 || arguments.length <= i ? void 0 : arguments[i]
						for (var n = 0; n < this.length; n += 1)
							if ("string" == typeof e) {
								var r = t.createElement("div")
								for (r.innerHTML = e; r.firstChild; ) this[n].appendChild(r.firstChild)
							} else if (e instanceof u)
								for (var a = 0; a < e.length; a += 1) this[n].appendChild(e[a])
							else this[n].appendChild(e)
					}
					return this
				},
				prepend: function (e) {
					var t,
						i,
						n = s()
					for (t = 0; t < this.length; t += 1)
						if ("string" == typeof e) {
							var r = n.createElement("div")
							for (r.innerHTML = e, i = r.childNodes.length - 1; i >= 0; i -= 1)
								this[t].insertBefore(r.childNodes[i], this[t].childNodes[0])
						} else if (e instanceof u)
							for (i = 0; i < e.length; i += 1) this[t].insertBefore(e[i], this[t].childNodes[0])
						else this[t].insertBefore(e, this[t].childNodes[0])
					return this
				},
				next: function (e) {
					return this.length > 0
						? e
							? this[0].nextElementSibling && f(this[0].nextElementSibling).is(e)
								? f([this[0].nextElementSibling])
								: f([])
							: this[0].nextElementSibling
								? f([this[0].nextElementSibling])
								: f([])
						: f([])
				},
				nextAll: function (e) {
					var t = [],
						i = this[0]
					if (!i) return f([])
					for (; i.nextElementSibling; ) {
						var n = i.nextElementSibling
						;(e ? f(n).is(e) && t.push(n) : t.push(n), (i = n))
					}
					return f(t)
				},
				prev: function (e) {
					if (this.length > 0) {
						var t = this[0]
						return e
							? t.previousElementSibling && f(t.previousElementSibling).is(e)
								? f([t.previousElementSibling])
								: f([])
							: t.previousElementSibling
								? f([t.previousElementSibling])
								: f([])
					}
					return f([])
				},
				prevAll: function (e) {
					var t = [],
						i = this[0]
					if (!i) return f([])
					for (; i.previousElementSibling; ) {
						var n = i.previousElementSibling
						;(e ? f(n).is(e) && t.push(n) : t.push(n), (i = n))
					}
					return f(t)
				},
				parent: function (e) {
					for (var t = [], i = 0; i < this.length; i += 1)
						null !== this[i].parentNode &&
							(e
								? f(this[i].parentNode).is(e) && t.push(this[i].parentNode)
								: t.push(this[i].parentNode))
					return f(t)
				},
				parents: function (e) {
					for (var t = [], i = 0; i < this.length; i += 1)
						for (var n = this[i].parentNode; n; )
							(e ? f(n).is(e) && t.push(n) : t.push(n), (n = n.parentNode))
					return f(t)
				},
				closest: function (e) {
					var t = this
					return void 0 === e ? f([]) : (t.is(e) || (t = t.parents(e).eq(0)), t)
				},
				find: function (e) {
					for (var t = [], i = 0; i < this.length; i += 1)
						for (var n = this[i].querySelectorAll(e), s = 0; s < n.length; s += 1) t.push(n[s])
					return f(t)
				},
				children: function (e) {
					for (var t = [], i = 0; i < this.length; i += 1)
						for (var n = this[i].children, s = 0; s < n.length; s += 1)
							(e && !f(n[s]).is(e)) || t.push(n[s])
					return f(t)
				},
				filter: function (e) {
					return f(h(this, e))
				},
				remove: function () {
					for (var e = 0; e < this.length; e += 1)
						this[e].parentNode && this[e].parentNode.removeChild(this[e])
					return this
				},
			}
			Object.keys(g).forEach(function (e) {
				Object.defineProperty(f.fn, e, { value: g[e], writable: !0 })
			})
			const y = f
			function b(e, t) {
				return (void 0 === t && (t = 0), setTimeout(e, t))
			}
			function w() {
				return Date.now()
			}
			function C(e, t) {
				void 0 === t && (t = "x")
				var i,
					n,
					s,
					r = a(),
					o = (function (e) {
						var t,
							i = a()
						return (
							i.getComputedStyle && (t = i.getComputedStyle(e, null)),
							!t && e.currentStyle && (t = e.currentStyle),
							t || (t = e.style),
							t
						)
					})(e)
				return (
					r.WebKitCSSMatrix
						? ((n = o.transform || o.webkitTransform).split(",").length > 6 &&
								(n = n
									.split(", ")
									.map(function (e) {
										return e.replace(",", ".")
									})
									.join(", ")),
							(s = new r.WebKitCSSMatrix("none" === n ? "" : n)))
						: (i = (s =
								o.MozTransform ||
								o.OTransform ||
								o.MsTransform ||
								o.msTransform ||
								o.transform ||
								o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"))
								.toString()
								.split(",")),
					"x" === t &&
						(n = r.WebKitCSSMatrix
							? s.m41
							: 16 === i.length
								? parseFloat(i[12])
								: parseFloat(i[4])),
					"y" === t &&
						(n = r.WebKitCSSMatrix
							? s.m42
							: 16 === i.length
								? parseFloat(i[13])
								: parseFloat(i[5])),
					n || 0
				)
			}
			function T(e) {
				return (
					"object" == typeof e &&
					null !== e &&
					e.constructor &&
					"Object" === Object.prototype.toString.call(e).slice(8, -1)
				)
			}
			function S() {
				for (
					var e,
						t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
						i = ["__proto__", "constructor", "prototype"],
						n = 1;
					n < arguments.length;
					n += 1
				) {
					var s = n < 0 || arguments.length <= n ? void 0 : arguments[n]
					if (
						null != s &&
						((e = s),
						!("undefined" != typeof window && void 0 !== window.HTMLElement
							? e instanceof HTMLElement
							: e && (1 === e.nodeType || 11 === e.nodeType)))
					)
						for (
							var r = Object.keys(Object(s)).filter(function (e) {
									return i.indexOf(e) < 0
								}),
								a = 0,
								o = r.length;
							a < o;
							a += 1
						) {
							var l = r[a],
								d = Object.getOwnPropertyDescriptor(s, l)
							void 0 !== d &&
								d.enumerable &&
								(T(t[l]) && T(s[l])
									? s[l].__swiper__
										? (t[l] = s[l])
										: S(t[l], s[l])
									: !T(t[l]) && T(s[l])
										? ((t[l] = {}), s[l].__swiper__ ? (t[l] = s[l]) : S(t[l], s[l]))
										: (t[l] = s[l]))
						}
				}
				return t
			}
			function E(e, t) {
				Object.keys(t).forEach(function (i) {
					;(T(t[i]) &&
						Object.keys(t[i]).forEach(function (n) {
							"function" == typeof t[i][n] && (t[i][n] = t[i][n].bind(e))
						}),
						(e[i] = t[i]))
				})
			}
			function x(e) {
				return (
					void 0 === e && (e = ""),
					"." +
						e
							.trim()
							.replace(/([\.:!\/])/g, "\\$1")
							.replace(/ /g, ".")
				)
			}
			function M(e, t, i, n) {
				var r = s()
				return (
					i &&
						Object.keys(n).forEach(function (i) {
							if (!t[i] && !0 === t.auto) {
								var s = r.createElement("div")
								;((s.className = n[i]), e.append(s), (t[i] = s))
							}
						}),
					t
				)
			}
			var k, O, P
			function L() {
				return (
					k ||
						(k = (function () {
							var e = a(),
								t = s()
							return {
								touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
								pointerEvents:
									!!e.PointerEvent &&
									"maxTouchPoints" in e.navigator &&
									e.navigator.maxTouchPoints >= 0,
								observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
								passiveListener: (function () {
									var t = !1
									try {
										var i = Object.defineProperty({}, "passive", {
											get: function () {
												t = !0
											},
										})
										e.addEventListener("testPassiveListener", null, i)
									} catch (e) {}
									return t
								})(),
								gestures: "ongesturestart" in e,
							}
						})()),
					k
				)
			}
			function A(e) {
				return (
					void 0 === e && (e = {}),
					O ||
						(O = (function (e) {
							var t = (void 0 === e ? {} : e).userAgent,
								i = L(),
								n = a(),
								s = n.navigator.platform,
								r = t || n.navigator.userAgent,
								o = { ios: !1, android: !1 },
								l = n.screen.width,
								d = n.screen.height,
								c = r.match(/(Android);?[\s\/]+([\d.]+)?/),
								u = r.match(/(iPad).*OS\s([\d_]+)/),
								p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
								h = !u && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
								f = "Win32" === s,
								v = "MacIntel" === s
							return (
								!u &&
									v &&
									i.touch &&
									[
										"1024x1366",
										"1366x1024",
										"834x1194",
										"1194x834",
										"834x1112",
										"1112x834",
										"768x1024",
										"1024x768",
										"820x1180",
										"1180x820",
										"810x1080",
										"1080x810",
									].indexOf(l + "x" + d) >= 0 &&
									((u = r.match(/(Version)\/([\d.]+)/)) || (u = [0, 1, "13_0_0"]), (v = !1)),
								c && !f && ((o.os = "android"), (o.android = !0)),
								(u || h || p) && ((o.os = "ios"), (o.ios = !0)),
								o
							)
						})(e)),
					O
				)
			}
			function z() {
				return (
					P ||
						(P = (function () {
							var e,
								t = a()
							return {
								isEdge: !!t.navigator.userAgent.match(/Edge/g),
								isSafari:
									((e = t.navigator.userAgent.toLowerCase()),
									e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
								isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
									t.navigator.userAgent,
								),
							}
						})()),
					P
				)
			}
			const I = {
				name: "resize",
				create: function () {
					var e = this
					S(e, {
						resize: {
							observer: null,
							createObserver: function () {
								e &&
									!e.destroyed &&
									e.initialized &&
									((e.resize.observer = new ResizeObserver(function (t) {
										var i = e.width,
											n = e.height,
											s = i,
											r = n
										;(t.forEach(function (t) {
											var i = t.contentBoxSize,
												n = t.contentRect,
												a = t.target
											;(a && a !== e.el) ||
												((s = n ? n.width : (i[0] || i).inlineSize),
												(r = n ? n.height : (i[0] || i).blockSize))
										}),
											(s === i && r === n) || e.resize.resizeHandler())
									})),
									e.resize.observer.observe(e.el))
							},
							removeObserver: function () {
								e.resize.observer &&
									e.resize.observer.unobserve &&
									e.el &&
									(e.resize.observer.unobserve(e.el), (e.resize.observer = null))
							},
							resizeHandler: function () {
								e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"))
							},
							orientationChangeHandler: function () {
								e && !e.destroyed && e.initialized && e.emit("orientationchange")
							},
						},
					})
				},
				on: {
					init: function (e) {
						var t = a()
						e.params.resizeObserver && void 0 !== a().ResizeObserver
							? e.resize.createObserver()
							: (t.addEventListener("resize", e.resize.resizeHandler),
								t.addEventListener("orientationchange", e.resize.orientationChangeHandler))
					},
					destroy: function (e) {
						var t = a()
						;(e.resize.removeObserver(),
							t.removeEventListener("resize", e.resize.resizeHandler),
							t.removeEventListener("orientationchange", e.resize.orientationChangeHandler))
					},
				},
			}
			function D() {
				return (
					(D =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var i = arguments[t]
								for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
							}
							return e
						}),
					D.apply(this, arguments)
				)
			}
			var B = {
				attach: function (e, t) {
					void 0 === t && (t = {})
					var i = a(),
						n = this,
						s = new (i.MutationObserver || i.WebkitMutationObserver)(function (e) {
							if (1 !== e.length) {
								var t = function () {
									n.emit("observerUpdate", e[0])
								}
								i.requestAnimationFrame ? i.requestAnimationFrame(t) : i.setTimeout(t, 0)
							} else n.emit("observerUpdate", e[0])
						})
					;(s.observe(e, {
						attributes: void 0 === t.attributes || t.attributes,
						childList: void 0 === t.childList || t.childList,
						characterData: void 0 === t.characterData || t.characterData,
					}),
						n.observer.observers.push(s))
				},
				init: function () {
					var e = this
					if (e.support.observer && e.params.observer) {
						if (e.params.observeParents)
							for (var t = e.$el.parents(), i = 0; i < t.length; i += 1) e.observer.attach(t[i])
						;(e.observer.attach(e.$el[0], { childList: e.params.observeSlideChildren }),
							e.observer.attach(e.$wrapperEl[0], { attributes: !1 }))
					}
				},
				destroy: function () {
					;(this.observer.observers.forEach(function (e) {
						e.disconnect()
					}),
						(this.observer.observers = []))
				},
			}
			const N = {
					name: "observer",
					params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
					create: function () {
						E(this, { observer: D({}, B, { observers: [] }) })
					},
					on: {
						init: function (e) {
							e.observer.init()
						},
						destroy: function (e) {
							e.observer.destroy()
						},
					},
				},
				j = {
					on: function (e, t, i) {
						var n = this
						if ("function" != typeof t) return n
						var s = i ? "unshift" : "push"
						return (
							e.split(" ").forEach(function (e) {
								;(n.eventsListeners[e] || (n.eventsListeners[e] = []), n.eventsListeners[e][s](t))
							}),
							n
						)
					},
					once: function (e, t, i) {
						var n = this
						if ("function" != typeof t) return n
						function s() {
							;(n.off(e, s), s.__emitterProxy && delete s.__emitterProxy)
							for (var i = arguments.length, r = new Array(i), a = 0; a < i; a++)
								r[a] = arguments[a]
							t.apply(n, r)
						}
						return ((s.__emitterProxy = t), n.on(e, s, i))
					},
					onAny: function (e, t) {
						var i = this
						if ("function" != typeof e) return i
						var n = t ? "unshift" : "push"
						return (i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[n](e), i)
					},
					offAny: function (e) {
						var t = this
						if (!t.eventsAnyListeners) return t
						var i = t.eventsAnyListeners.indexOf(e)
						return (i >= 0 && t.eventsAnyListeners.splice(i, 1), t)
					},
					off: function (e, t) {
						var i = this
						return i.eventsListeners
							? (e.split(" ").forEach(function (e) {
									void 0 === t
										? (i.eventsListeners[e] = [])
										: i.eventsListeners[e] &&
											i.eventsListeners[e].forEach(function (n, s) {
												;(n === t || (n.__emitterProxy && n.__emitterProxy === t)) &&
													i.eventsListeners[e].splice(s, 1)
											})
								}),
								i)
							: i
					},
					emit: function () {
						var e,
							t,
							i,
							n = this
						if (!n.eventsListeners) return n
						for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++) r[a] = arguments[a]
						return (
							"string" == typeof r[0] || Array.isArray(r[0])
								? ((e = r[0]), (t = r.slice(1, r.length)), (i = n))
								: ((e = r[0].events), (t = r[0].data), (i = r[0].context || n)),
							t.unshift(i),
							(Array.isArray(e) ? e : e.split(" ")).forEach(function (e) {
								;(n.eventsAnyListeners &&
									n.eventsAnyListeners.length &&
									n.eventsAnyListeners.forEach(function (n) {
										n.apply(i, [e].concat(t))
									}),
									n.eventsListeners &&
										n.eventsListeners[e] &&
										n.eventsListeners[e].forEach(function (e) {
											e.apply(i, t)
										}))
							}),
							n
						)
					},
				}
			const $ = {
				updateSize: function () {
					var e,
						t,
						i = this,
						n = i.$el
					;((e =
						void 0 !== i.params.width && null !== i.params.width
							? i.params.width
							: n[0].clientWidth),
						(t =
							void 0 !== i.params.height && null !== i.params.height
								? i.params.height
								: n[0].clientHeight),
						(0 === e && i.isHorizontal()) ||
							(0 === t && i.isVertical()) ||
							((e =
								e -
								parseInt(n.css("padding-left") || 0, 10) -
								parseInt(n.css("padding-right") || 0, 10)),
							(t =
								t -
								parseInt(n.css("padding-top") || 0, 10) -
								parseInt(n.css("padding-bottom") || 0, 10)),
							Number.isNaN(e) && (e = 0),
							Number.isNaN(t) && (t = 0),
							S(i, { width: e, height: t, size: i.isHorizontal() ? e : t })))
				},
				updateSlides: function () {
					var e = this
					function t(t) {
						return e.isHorizontal()
							? t
							: {
									width: "height",
									"margin-top": "margin-left",
									"margin-bottom ": "margin-right",
									"margin-left": "margin-top",
									"margin-right": "margin-bottom",
									"padding-left": "padding-top",
									"padding-right": "padding-bottom",
									marginRight: "marginBottom",
								}[t]
					}
					function i(e, i) {
						return parseFloat(e.getPropertyValue(t(i)) || 0)
					}
					var n = e.params,
						s = e.$wrapperEl,
						r = e.size,
						a = e.rtlTranslate,
						o = e.wrongRTL,
						l = e.virtual && n.virtual.enabled,
						d = l ? e.virtual.slides.length : e.slides.length,
						c = s.children("." + e.params.slideClass),
						u = l ? e.virtual.slides.length : c.length,
						p = [],
						h = [],
						f = [],
						v = n.slidesOffsetBefore
					"function" == typeof v && (v = n.slidesOffsetBefore.call(e))
					var m = n.slidesOffsetAfter
					"function" == typeof m && (m = n.slidesOffsetAfter.call(e))
					var g = e.snapGrid.length,
						y = e.slidesGrid.length,
						b = n.spaceBetween,
						w = -v,
						C = 0,
						T = 0
					if (void 0 !== r) {
						var E, x
						;("string" == typeof b &&
							b.indexOf("%") >= 0 &&
							(b = (parseFloat(b.replace("%", "")) / 100) * r),
							(e.virtualSize = -b),
							a
								? c.css({ marginLeft: "", marginBottom: "", marginTop: "" })
								: c.css({ marginRight: "", marginBottom: "", marginTop: "" }),
							n.slidesPerColumn > 1 &&
								((E =
									Math.floor(u / n.slidesPerColumn) === u / e.params.slidesPerColumn
										? u
										: Math.ceil(u / n.slidesPerColumn) * n.slidesPerColumn),
								"auto" !== n.slidesPerView &&
									"row" === n.slidesPerColumnFill &&
									(E = Math.max(E, n.slidesPerView * n.slidesPerColumn))))
						for (
							var M,
								k,
								O,
								P = n.slidesPerColumn,
								L = E / P,
								A = Math.floor(u / n.slidesPerColumn),
								z = 0;
							z < u;
							z += 1
						) {
							x = 0
							var I = c.eq(z)
							if (n.slidesPerColumn > 1) {
								var D = void 0,
									B = void 0,
									N = void 0
								if ("row" === n.slidesPerColumnFill && n.slidesPerGroup > 1) {
									var j = Math.floor(z / (n.slidesPerGroup * n.slidesPerColumn)),
										$ = z - n.slidesPerColumn * n.slidesPerGroup * j,
										_ =
											0 === j
												? n.slidesPerGroup
												: Math.min(Math.ceil((u - j * P * n.slidesPerGroup) / P), n.slidesPerGroup)
									;((D =
										(B = $ - (N = Math.floor($ / _)) * _ + j * n.slidesPerGroup) + (N * E) / P),
										I.css({
											"-webkit-box-ordinal-group": D,
											"-moz-box-ordinal-group": D,
											"-ms-flex-order": D,
											"-webkit-order": D,
											order: D,
										}))
								} else
									"column" === n.slidesPerColumnFill
										? ((N = z - (B = Math.floor(z / P)) * P),
											(B > A || (B === A && N === P - 1)) && (N += 1) >= P && ((N = 0), (B += 1)))
										: (B = z - (N = Math.floor(z / L)) * L)
								I.css(t("margin-top"), 0 !== N ? n.spaceBetween && n.spaceBetween + "px" : "")
							}
							if ("none" !== I.css("display")) {
								if ("auto" === n.slidesPerView) {
									var H = getComputedStyle(I[0]),
										G = I[0].style.transform,
										F = I[0].style.webkitTransform
									if (
										(G && (I[0].style.transform = "none"),
										F && (I[0].style.webkitTransform = "none"),
										n.roundLengths)
									)
										x = e.isHorizontal() ? I.outerWidth(!0) : I.outerHeight(!0)
									else {
										var W = i(H, "width"),
											V = i(H, "padding-left"),
											q = i(H, "padding-right"),
											R = i(H, "margin-left"),
											X = i(H, "margin-right"),
											Y = H.getPropertyValue("box-sizing")
										if (Y && "border-box" === Y) x = W + R + X
										else {
											var U = I[0],
												K = U.clientWidth
											x = W + V + q + R + X + (U.offsetWidth - K)
										}
									}
									;(G && (I[0].style.transform = G),
										F && (I[0].style.webkitTransform = F),
										n.roundLengths && (x = Math.floor(x)))
								} else
									((x = (r - (n.slidesPerView - 1) * b) / n.slidesPerView),
										n.roundLengths && (x = Math.floor(x)),
										c[z] && (c[z].style[t("width")] = x + "px"))
								;(c[z] && (c[z].swiperSlideSize = x),
									f.push(x),
									n.centeredSlides
										? ((w = w + x / 2 + C / 2 + b),
											0 === C && 0 !== z && (w = w - r / 2 - b),
											0 === z && (w = w - r / 2 - b),
											Math.abs(w) < 0.001 && (w = 0),
											n.roundLengths && (w = Math.floor(w)),
											T % n.slidesPerGroup == 0 && p.push(w),
											h.push(w))
										: (n.roundLengths && (w = Math.floor(w)),
											(T - Math.min(e.params.slidesPerGroupSkip, T)) % e.params.slidesPerGroup ==
												0 && p.push(w),
											h.push(w),
											(w = w + x + b)),
									(e.virtualSize += x + b),
									(C = x),
									(T += 1))
							}
						}
						if (
							((e.virtualSize = Math.max(e.virtualSize, r) + m),
							a &&
								o &&
								("slide" === n.effect || "coverflow" === n.effect) &&
								s.css({ width: e.virtualSize + n.spaceBetween + "px" }),
							n.setWrapperSize)
						)
							s.css((((k = {})[t("width")] = e.virtualSize + n.spaceBetween + "px"), k))
						if (n.slidesPerColumn > 1)
							if (
								((e.virtualSize = (x + n.spaceBetween) * E),
								(e.virtualSize = Math.ceil(e.virtualSize / n.slidesPerColumn) - n.spaceBetween),
								s.css((((O = {})[t("width")] = e.virtualSize + n.spaceBetween + "px"), O)),
								n.centeredSlides)
							) {
								M = []
								for (var Z = 0; Z < p.length; Z += 1) {
									var J = p[Z]
									;(n.roundLengths && (J = Math.floor(J)), p[Z] < e.virtualSize + p[0] && M.push(J))
								}
								p = M
							}
						if (!n.centeredSlides) {
							M = []
							for (var Q = 0; Q < p.length; Q += 1) {
								var ee = p[Q]
								;(n.roundLengths && (ee = Math.floor(ee)), p[Q] <= e.virtualSize - r && M.push(ee))
							}
							;((p = M),
								Math.floor(e.virtualSize - r) - Math.floor(p[p.length - 1]) > 1 &&
									p.push(e.virtualSize - r))
						}
						if ((0 === p.length && (p = [0]), 0 !== n.spaceBetween)) {
							var te,
								ie = e.isHorizontal() && a ? "marginLeft" : t("marginRight")
							c.filter(function (e, t) {
								return !n.cssMode || t !== c.length - 1
							}).css((((te = {})[ie] = b + "px"), te))
						}
						if (n.centeredSlides && n.centeredSlidesBounds) {
							var ne = 0
							f.forEach(function (e) {
								ne += e + (n.spaceBetween ? n.spaceBetween : 0)
							})
							var se = (ne -= n.spaceBetween) - r
							p = p.map(function (e) {
								return e < 0 ? -v : e > se ? se + m : e
							})
						}
						if (n.centerInsufficientSlides) {
							var re = 0
							if (
								(f.forEach(function (e) {
									re += e + (n.spaceBetween ? n.spaceBetween : 0)
								}),
								(re -= n.spaceBetween) < r)
							) {
								var ae = (r - re) / 2
								;(p.forEach(function (e, t) {
									p[t] = e - ae
								}),
									h.forEach(function (e, t) {
										h[t] = e + ae
									}))
							}
						}
						;(S(e, { slides: c, snapGrid: p, slidesGrid: h, slidesSizesGrid: f }),
							u !== d && e.emit("slidesLengthChange"),
							p.length !== g &&
								(e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
							h.length !== y && e.emit("slidesGridLengthChange"),
							(n.watchSlidesProgress || n.watchSlidesVisibility) && e.updateSlidesOffset())
					}
				},
				updateAutoHeight: function (e) {
					var t,
						i = this,
						n = [],
						s = i.virtual && i.params.virtual.enabled,
						r = 0
					"number" == typeof e ? i.setTransition(e) : !0 === e && i.setTransition(i.params.speed)
					var a = function (e) {
						return s
							? i.slides.filter(function (t) {
									return parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e
								})[0]
							: i.slides.eq(e)[0]
					}
					if ("auto" !== i.params.slidesPerView && i.params.slidesPerView > 1)
						if (i.params.centeredSlides)
							i.visibleSlides.each(function (e) {
								n.push(e)
							})
						else
							for (t = 0; t < Math.ceil(i.params.slidesPerView); t += 1) {
								var o = i.activeIndex + t
								if (o > i.slides.length && !s) break
								n.push(a(o))
							}
					else n.push(a(i.activeIndex))
					for (t = 0; t < n.length; t += 1)
						if (void 0 !== n[t]) {
							var l = n[t].offsetHeight
							r = l > r ? l : r
						}
					r && i.$wrapperEl.css("height", r + "px")
				},
				updateSlidesOffset: function () {
					for (var e = this.slides, t = 0; t < e.length; t += 1)
						e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop
				},
				updateSlidesProgress: function (e) {
					void 0 === e && (e = (this && this.translate) || 0)
					var t = this,
						i = t.params,
						n = t.slides,
						s = t.rtlTranslate
					if (0 !== n.length) {
						void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset()
						var r = -e
						;(s && (r = e),
							n.removeClass(i.slideVisibleClass),
							(t.visibleSlidesIndexes = []),
							(t.visibleSlides = []))
						for (var a = 0; a < n.length; a += 1) {
							var o = n[a],
								l =
									(r + (i.centeredSlides ? t.minTranslate() : 0) - o.swiperSlideOffset) /
									(o.swiperSlideSize + i.spaceBetween)
							if (i.watchSlidesVisibility || (i.centeredSlides && i.autoHeight)) {
								var d = -(r - o.swiperSlideOffset),
									c = d + t.slidesSizesGrid[a]
								;((d >= 0 && d < t.size - 1) ||
									(c > 1 && c <= t.size) ||
									(d <= 0 && c >= t.size)) &&
									(t.visibleSlides.push(o),
									t.visibleSlidesIndexes.push(a),
									n.eq(a).addClass(i.slideVisibleClass))
							}
							o.progress = s ? -l : l
						}
						t.visibleSlides = y(t.visibleSlides)
					}
				},
				updateProgress: function (e) {
					var t = this
					if (void 0 === e) {
						var i = t.rtlTranslate ? -1 : 1
						e = (t && t.translate && t.translate * i) || 0
					}
					var n = t.params,
						s = t.maxTranslate() - t.minTranslate(),
						r = t.progress,
						a = t.isBeginning,
						o = t.isEnd,
						l = a,
						d = o
					;(0 === s
						? ((r = 0), (a = !0), (o = !0))
						: ((a = (r = (e - t.minTranslate()) / s) <= 0), (o = r >= 1)),
						S(t, { progress: r, isBeginning: a, isEnd: o }),
						(n.watchSlidesProgress ||
							n.watchSlidesVisibility ||
							(n.centeredSlides && n.autoHeight)) &&
							t.updateSlidesProgress(e),
						a && !l && t.emit("reachBeginning toEdge"),
						o && !d && t.emit("reachEnd toEdge"),
						((l && !a) || (d && !o)) && t.emit("fromEdge"),
						t.emit("progress", r))
				},
				updateSlidesClasses: function () {
					var e,
						t = this,
						i = t.slides,
						n = t.params,
						s = t.$wrapperEl,
						r = t.activeIndex,
						a = t.realIndex,
						o = t.virtual && n.virtual.enabled
					;(i.removeClass(
						n.slideActiveClass +
							" " +
							n.slideNextClass +
							" " +
							n.slidePrevClass +
							" " +
							n.slideDuplicateActiveClass +
							" " +
							n.slideDuplicateNextClass +
							" " +
							n.slideDuplicatePrevClass,
					),
						(e = o
							? t.$wrapperEl.find("." + n.slideClass + '[data-swiper-slide-index="' + r + '"]')
							: i.eq(r)).addClass(n.slideActiveClass),
						n.loop &&
							(e.hasClass(n.slideDuplicateClass)
								? s
										.children(
											"." +
												n.slideClass +
												":not(." +
												n.slideDuplicateClass +
												')[data-swiper-slide-index="' +
												a +
												'"]',
										)
										.addClass(n.slideDuplicateActiveClass)
								: s
										.children(
											"." +
												n.slideClass +
												"." +
												n.slideDuplicateClass +
												'[data-swiper-slide-index="' +
												a +
												'"]',
										)
										.addClass(n.slideDuplicateActiveClass)))
					var l = e
						.nextAll("." + n.slideClass)
						.eq(0)
						.addClass(n.slideNextClass)
					n.loop && 0 === l.length && (l = i.eq(0)).addClass(n.slideNextClass)
					var d = e
						.prevAll("." + n.slideClass)
						.eq(0)
						.addClass(n.slidePrevClass)
					;(n.loop && 0 === d.length && (d = i.eq(-1)).addClass(n.slidePrevClass),
						n.loop &&
							(l.hasClass(n.slideDuplicateClass)
								? s
										.children(
											"." +
												n.slideClass +
												":not(." +
												n.slideDuplicateClass +
												')[data-swiper-slide-index="' +
												l.attr("data-swiper-slide-index") +
												'"]',
										)
										.addClass(n.slideDuplicateNextClass)
								: s
										.children(
											"." +
												n.slideClass +
												"." +
												n.slideDuplicateClass +
												'[data-swiper-slide-index="' +
												l.attr("data-swiper-slide-index") +
												'"]',
										)
										.addClass(n.slideDuplicateNextClass),
							d.hasClass(n.slideDuplicateClass)
								? s
										.children(
											"." +
												n.slideClass +
												":not(." +
												n.slideDuplicateClass +
												')[data-swiper-slide-index="' +
												d.attr("data-swiper-slide-index") +
												'"]',
										)
										.addClass(n.slideDuplicatePrevClass)
								: s
										.children(
											"." +
												n.slideClass +
												"." +
												n.slideDuplicateClass +
												'[data-swiper-slide-index="' +
												d.attr("data-swiper-slide-index") +
												'"]',
										)
										.addClass(n.slideDuplicatePrevClass)),
						t.emitSlidesClasses())
				},
				updateActiveIndex: function (e) {
					var t,
						i = this,
						n = i.rtlTranslate ? i.translate : -i.translate,
						s = i.slidesGrid,
						r = i.snapGrid,
						a = i.params,
						o = i.activeIndex,
						l = i.realIndex,
						d = i.snapIndex,
						c = e
					if (void 0 === c) {
						for (var u = 0; u < s.length; u += 1)
							void 0 !== s[u + 1]
								? n >= s[u] && n < s[u + 1] - (s[u + 1] - s[u]) / 2
									? (c = u)
									: n >= s[u] && n < s[u + 1] && (c = u + 1)
								: n >= s[u] && (c = u)
						a.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0)
					}
					if (r.indexOf(n) >= 0) t = r.indexOf(n)
					else {
						var p = Math.min(a.slidesPerGroupSkip, c)
						t = p + Math.floor((c - p) / a.slidesPerGroup)
					}
					if ((t >= r.length && (t = r.length - 1), c !== o)) {
						var h = parseInt(i.slides.eq(c).attr("data-swiper-slide-index") || c, 10)
						;(S(i, { snapIndex: t, realIndex: h, previousIndex: o, activeIndex: c }),
							i.emit("activeIndexChange"),
							i.emit("snapIndexChange"),
							l !== h && i.emit("realIndexChange"),
							(i.initialized || i.params.runCallbacksOnInit) && i.emit("slideChange"))
					} else t !== d && ((i.snapIndex = t), i.emit("snapIndexChange"))
				},
				updateClickedSlide: function (e) {
					var t,
						i = this,
						n = i.params,
						s = y(e.target).closest("." + n.slideClass)[0],
						r = !1
					if (s)
						for (var a = 0; a < i.slides.length; a += 1)
							if (i.slides[a] === s) {
								;((r = !0), (t = a))
								break
							}
					if (!s || !r) return ((i.clickedSlide = void 0), void (i.clickedIndex = void 0))
					;((i.clickedSlide = s),
						i.virtual && i.params.virtual.enabled
							? (i.clickedIndex = parseInt(y(s).attr("data-swiper-slide-index"), 10))
							: (i.clickedIndex = t),
						n.slideToClickedSlide &&
							void 0 !== i.clickedIndex &&
							i.clickedIndex !== i.activeIndex &&
							i.slideToClickedSlide())
				},
			}
			const _ = {
				getTranslate: function (e) {
					void 0 === e && (e = this.isHorizontal() ? "x" : "y")
					var t = this,
						i = t.params,
						n = t.rtlTranslate,
						s = t.translate,
						r = t.$wrapperEl
					if (i.virtualTranslate) return n ? -s : s
					if (i.cssMode) return s
					var a = C(r[0], e)
					return (n && (a = -a), a || 0)
				},
				setTranslate: function (e, t) {
					var i = this,
						n = i.rtlTranslate,
						s = i.params,
						r = i.$wrapperEl,
						a = i.wrapperEl,
						o = i.progress,
						l = 0,
						d = 0
					;(i.isHorizontal() ? (l = n ? -e : e) : (d = e),
						s.roundLengths && ((l = Math.floor(l)), (d = Math.floor(d))),
						s.cssMode
							? (a[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -l : -d)
							: s.virtualTranslate || r.transform("translate3d(" + l + "px, " + d + "px, 0px)"),
						(i.previousTranslate = i.translate),
						(i.translate = i.isHorizontal() ? l : d))
					var c = i.maxTranslate() - i.minTranslate()
					;((0 === c ? 0 : (e - i.minTranslate()) / c) !== o && i.updateProgress(e),
						i.emit("setTranslate", i.translate, t))
				},
				minTranslate: function () {
					return -this.snapGrid[0]
				},
				maxTranslate: function () {
					return -this.snapGrid[this.snapGrid.length - 1]
				},
				translateTo: function (e, t, i, n, s) {
					;(void 0 === e && (e = 0),
						void 0 === t && (t = this.params.speed),
						void 0 === i && (i = !0),
						void 0 === n && (n = !0))
					var r = this,
						a = r.params,
						o = r.wrapperEl
					if (r.animating && a.preventInteractionOnTransition) return !1
					var l,
						d = r.minTranslate(),
						c = r.maxTranslate()
					if (((l = n && e > d ? d : n && e < c ? c : e), r.updateProgress(l), a.cssMode)) {
						var u,
							p = r.isHorizontal()
						if (0 === t) o[p ? "scrollLeft" : "scrollTop"] = -l
						else if (o.scrollTo)
							o.scrollTo((((u = {})[p ? "left" : "top"] = -l), (u.behavior = "smooth"), u))
						else o[p ? "scrollLeft" : "scrollTop"] = -l
						return !0
					}
					return (
						0 === t
							? (r.setTransition(0),
								r.setTranslate(l),
								i && (r.emit("beforeTransitionStart", t, s), r.emit("transitionEnd")))
							: (r.setTransition(t),
								r.setTranslate(l),
								i && (r.emit("beforeTransitionStart", t, s), r.emit("transitionStart")),
								r.animating ||
									((r.animating = !0),
									r.onTranslateToWrapperTransitionEnd ||
										(r.onTranslateToWrapperTransitionEnd = function (e) {
											r &&
												!r.destroyed &&
												e.target === this &&
												(r.$wrapperEl[0].removeEventListener(
													"transitionend",
													r.onTranslateToWrapperTransitionEnd,
												),
												r.$wrapperEl[0].removeEventListener(
													"webkitTransitionEnd",
													r.onTranslateToWrapperTransitionEnd,
												),
												(r.onTranslateToWrapperTransitionEnd = null),
												delete r.onTranslateToWrapperTransitionEnd,
												i && r.emit("transitionEnd"))
										}),
									r.$wrapperEl[0].addEventListener(
										"transitionend",
										r.onTranslateToWrapperTransitionEnd,
									),
									r.$wrapperEl[0].addEventListener(
										"webkitTransitionEnd",
										r.onTranslateToWrapperTransitionEnd,
									))),
						!0
					)
				},
			}
			const H = {
				setTransition: function (e, t) {
					var i = this
					;(i.params.cssMode || i.$wrapperEl.transition(e), i.emit("setTransition", e, t))
				},
				transitionStart: function (e, t) {
					void 0 === e && (e = !0)
					var i = this,
						n = i.activeIndex,
						s = i.params,
						r = i.previousIndex
					if (!s.cssMode) {
						s.autoHeight && i.updateAutoHeight()
						var a = t
						if (
							(a || (a = n > r ? "next" : n < r ? "prev" : "reset"),
							i.emit("transitionStart"),
							e && n !== r)
						) {
							if ("reset" === a) return void i.emit("slideResetTransitionStart")
							;(i.emit("slideChangeTransitionStart"),
								"next" === a
									? i.emit("slideNextTransitionStart")
									: i.emit("slidePrevTransitionStart"))
						}
					}
				},
				transitionEnd: function (e, t) {
					void 0 === e && (e = !0)
					var i = this,
						n = i.activeIndex,
						s = i.previousIndex,
						r = i.params
					if (((i.animating = !1), !r.cssMode)) {
						i.setTransition(0)
						var a = t
						if (
							(a || (a = n > s ? "next" : n < s ? "prev" : "reset"),
							i.emit("transitionEnd"),
							e && n !== s)
						) {
							if ("reset" === a) return void i.emit("slideResetTransitionEnd")
							;(i.emit("slideChangeTransitionEnd"),
								"next" === a ? i.emit("slideNextTransitionEnd") : i.emit("slidePrevTransitionEnd"))
						}
					}
				},
			}
			const G = {
				slideTo: function (e, t, i, n, s) {
					if (
						(void 0 === e && (e = 0),
						void 0 === t && (t = this.params.speed),
						void 0 === i && (i = !0),
						"number" != typeof e && "string" != typeof e)
					)
						throw new Error(
							"The 'index' argument cannot have type other than 'number' or 'string'. [" +
								typeof e +
								"] given.",
						)
					if ("string" == typeof e) {
						var r = parseInt(e, 10)
						if (!isFinite(r))
							throw new Error(
								"The passed-in 'index' (string) couldn't be converted to 'number'. [" +
									e +
									"] given.",
							)
						e = r
					}
					var a = this,
						o = e
					o < 0 && (o = 0)
					var l = a.params,
						d = a.snapGrid,
						c = a.slidesGrid,
						u = a.previousIndex,
						p = a.activeIndex,
						h = a.rtlTranslate,
						f = a.wrapperEl,
						v = a.enabled
					if ((a.animating && l.preventInteractionOnTransition) || (!v && !n && !s)) return !1
					var m = Math.min(a.params.slidesPerGroupSkip, o),
						g = m + Math.floor((o - m) / a.params.slidesPerGroup)
					;(g >= d.length && (g = d.length - 1),
						(p || l.initialSlide || 0) === (u || 0) && i && a.emit("beforeSlideChangeStart"))
					var y,
						b = -d[g]
					if ((a.updateProgress(b), l.normalizeSlideIndex))
						for (var w = 0; w < c.length; w += 1) {
							var C = -Math.floor(100 * b),
								T = Math.floor(100 * c[w]),
								S = Math.floor(100 * c[w + 1])
							void 0 !== c[w + 1]
								? C >= T && C < S - (S - T) / 2
									? (o = w)
									: C >= T && C < S && (o = w + 1)
								: C >= T && (o = w)
						}
					if (a.initialized && o !== p) {
						if (!a.allowSlideNext && b < a.translate && b < a.minTranslate()) return !1
						if (!a.allowSlidePrev && b > a.translate && b > a.maxTranslate() && (p || 0) !== o)
							return !1
					}
					if (
						((y = o > p ? "next" : o < p ? "prev" : "reset"),
						(h && -b === a.translate) || (!h && b === a.translate))
					)
						return (
							a.updateActiveIndex(o),
							l.autoHeight && a.updateAutoHeight(),
							a.updateSlidesClasses(),
							"slide" !== l.effect && a.setTranslate(b),
							"reset" !== y && (a.transitionStart(i, y), a.transitionEnd(i, y)),
							!1
						)
					if (l.cssMode) {
						var E,
							x = a.isHorizontal(),
							M = -b
						if ((h && (M = f.scrollWidth - f.offsetWidth - M), 0 === t))
							f[x ? "scrollLeft" : "scrollTop"] = M
						else if (f.scrollTo)
							f.scrollTo((((E = {})[x ? "left" : "top"] = M), (E.behavior = "smooth"), E))
						else f[x ? "scrollLeft" : "scrollTop"] = M
						return !0
					}
					return (
						0 === t
							? (a.setTransition(0),
								a.setTranslate(b),
								a.updateActiveIndex(o),
								a.updateSlidesClasses(),
								a.emit("beforeTransitionStart", t, n),
								a.transitionStart(i, y),
								a.transitionEnd(i, y))
							: (a.setTransition(t),
								a.setTranslate(b),
								a.updateActiveIndex(o),
								a.updateSlidesClasses(),
								a.emit("beforeTransitionStart", t, n),
								a.transitionStart(i, y),
								a.animating ||
									((a.animating = !0),
									a.onSlideToWrapperTransitionEnd ||
										(a.onSlideToWrapperTransitionEnd = function (e) {
											a &&
												!a.destroyed &&
												e.target === this &&
												(a.$wrapperEl[0].removeEventListener(
													"transitionend",
													a.onSlideToWrapperTransitionEnd,
												),
												a.$wrapperEl[0].removeEventListener(
													"webkitTransitionEnd",
													a.onSlideToWrapperTransitionEnd,
												),
												(a.onSlideToWrapperTransitionEnd = null),
												delete a.onSlideToWrapperTransitionEnd,
												a.transitionEnd(i, y))
										}),
									a.$wrapperEl[0].addEventListener(
										"transitionend",
										a.onSlideToWrapperTransitionEnd,
									),
									a.$wrapperEl[0].addEventListener(
										"webkitTransitionEnd",
										a.onSlideToWrapperTransitionEnd,
									))),
						!0
					)
				},
				slideToLoop: function (e, t, i, n) {
					;(void 0 === e && (e = 0),
						void 0 === t && (t = this.params.speed),
						void 0 === i && (i = !0))
					var s = this,
						r = e
					return (s.params.loop && (r += s.loopedSlides), s.slideTo(r, t, i, n))
				},
				slideNext: function (e, t, i) {
					;(void 0 === e && (e = this.params.speed), void 0 === t && (t = !0))
					var n = this,
						s = n.params,
						r = n.animating
					if (!n.enabled) return n
					var a = n.activeIndex < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup
					if (s.loop) {
						if (r && s.loopPreventsSlide) return !1
						;(n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft))
					}
					return n.slideTo(n.activeIndex + a, e, t, i)
				},
				slidePrev: function (e, t, i) {
					;(void 0 === e && (e = this.params.speed), void 0 === t && (t = !0))
					var n = this,
						s = n.params,
						r = n.animating,
						a = n.snapGrid,
						o = n.slidesGrid,
						l = n.rtlTranslate
					if (!n.enabled) return n
					if (s.loop) {
						if (r && s.loopPreventsSlide) return !1
						;(n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft))
					}
					function d(e) {
						return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
					}
					var c,
						u = d(l ? n.translate : -n.translate),
						p = a.map(function (e) {
							return d(e)
						}),
						h = a[p.indexOf(u) - 1]
					return (
						void 0 === h &&
							s.cssMode &&
							a.forEach(function (e) {
								!h && u >= e && (h = e)
							}),
						void 0 !== h && (c = o.indexOf(h)) < 0 && (c = n.activeIndex - 1),
						n.slideTo(c, e, t, i)
					)
				},
				slideReset: function (e, t, i) {
					return (
						void 0 === e && (e = this.params.speed),
						void 0 === t && (t = !0),
						this.slideTo(this.activeIndex, e, t, i)
					)
				},
				slideToClosest: function (e, t, i, n) {
					;(void 0 === e && (e = this.params.speed),
						void 0 === t && (t = !0),
						void 0 === n && (n = 0.5))
					var s = this,
						r = s.activeIndex,
						a = Math.min(s.params.slidesPerGroupSkip, r),
						o = a + Math.floor((r - a) / s.params.slidesPerGroup),
						l = s.rtlTranslate ? s.translate : -s.translate
					if (l >= s.snapGrid[o]) {
						var d = s.snapGrid[o]
						l - d > (s.snapGrid[o + 1] - d) * n && (r += s.params.slidesPerGroup)
					} else {
						var c = s.snapGrid[o - 1]
						l - c <= (s.snapGrid[o] - c) * n && (r -= s.params.slidesPerGroup)
					}
					return (
						(r = Math.max(r, 0)),
						(r = Math.min(r, s.slidesGrid.length - 1)),
						s.slideTo(r, e, t, i)
					)
				},
				slideToClickedSlide: function () {
					var e,
						t = this,
						i = t.params,
						n = t.$wrapperEl,
						s = "auto" === i.slidesPerView ? t.slidesPerViewDynamic() : i.slidesPerView,
						r = t.clickedIndex
					if (i.loop) {
						if (t.animating) return
						;((e = parseInt(y(t.clickedSlide).attr("data-swiper-slide-index"), 10)),
							i.centeredSlides
								? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2
									? (t.loopFix(),
										(r = n
											.children(
												"." +
													i.slideClass +
													'[data-swiper-slide-index="' +
													e +
													'"]:not(.' +
													i.slideDuplicateClass +
													")",
											)
											.eq(0)
											.index()),
										b(function () {
											t.slideTo(r)
										}))
									: t.slideTo(r)
								: r > t.slides.length - s
									? (t.loopFix(),
										(r = n
											.children(
												"." +
													i.slideClass +
													'[data-swiper-slide-index="' +
													e +
													'"]:not(.' +
													i.slideDuplicateClass +
													")",
											)
											.eq(0)
											.index()),
										b(function () {
											t.slideTo(r)
										}))
									: t.slideTo(r))
					} else t.slideTo(r)
				},
			}
			const F = {
				loopCreate: function () {
					var e = this,
						t = s(),
						i = e.params,
						n = e.$wrapperEl
					n.children("." + i.slideClass + "." + i.slideDuplicateClass).remove()
					var r = n.children("." + i.slideClass)
					if (i.loopFillGroupWithBlank) {
						var a = i.slidesPerGroup - (r.length % i.slidesPerGroup)
						if (a !== i.slidesPerGroup) {
							for (var o = 0; o < a; o += 1) {
								var l = y(t.createElement("div")).addClass(i.slideClass + " " + i.slideBlankClass)
								n.append(l)
							}
							r = n.children("." + i.slideClass)
						}
					}
					;("auto" !== i.slidesPerView || i.loopedSlides || (i.loopedSlides = r.length),
						(e.loopedSlides = Math.ceil(parseFloat(i.loopedSlides || i.slidesPerView, 10))),
						(e.loopedSlides += i.loopAdditionalSlides),
						e.loopedSlides > r.length && (e.loopedSlides = r.length))
					var d = [],
						c = []
					r.each(function (t, i) {
						var n = y(t)
						;(i < e.loopedSlides && c.push(t),
							i < r.length && i >= r.length - e.loopedSlides && d.push(t),
							n.attr("data-swiper-slide-index", i))
					})
					for (var u = 0; u < c.length; u += 1)
						n.append(y(c[u].cloneNode(!0)).addClass(i.slideDuplicateClass))
					for (var p = d.length - 1; p >= 0; p -= 1)
						n.prepend(y(d[p].cloneNode(!0)).addClass(i.slideDuplicateClass))
				},
				loopFix: function () {
					var e = this
					e.emit("beforeLoopFix")
					var t,
						i = e.activeIndex,
						n = e.slides,
						s = e.loopedSlides,
						r = e.allowSlidePrev,
						a = e.allowSlideNext,
						o = e.snapGrid,
						l = e.rtlTranslate
					;((e.allowSlidePrev = !0), (e.allowSlideNext = !0))
					var d = -o[i] - e.getTranslate()
					if (i < s)
						((t = n.length - 3 * s + i),
							(t += s),
							e.slideTo(t, 0, !1, !0) &&
								0 !== d &&
								e.setTranslate((l ? -e.translate : e.translate) - d))
					else if (i >= n.length - s) {
						;((t = -n.length + i + s),
							(t += s),
							e.slideTo(t, 0, !1, !0) &&
								0 !== d &&
								e.setTranslate((l ? -e.translate : e.translate) - d))
					}
					;((e.allowSlidePrev = r), (e.allowSlideNext = a), e.emit("loopFix"))
				},
				loopDestroy: function () {
					var e = this,
						t = e.$wrapperEl,
						i = e.params,
						n = e.slides
					;(t
						.children(
							"." +
								i.slideClass +
								"." +
								i.slideDuplicateClass +
								",." +
								i.slideClass +
								"." +
								i.slideBlankClass,
						)
						.remove(),
						n.removeAttr("data-swiper-slide-index"))
				},
			}
			const W = {
				setGrabCursor: function (e) {
					var t = this
					if (
						!(
							t.support.touch ||
							!t.params.simulateTouch ||
							(t.params.watchOverflow && t.isLocked) ||
							t.params.cssMode
						)
					) {
						var i = t.el
						;((i.style.cursor = "move"),
							(i.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
							(i.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
							(i.style.cursor = e ? "grabbing" : "grab"))
					}
				},
				unsetGrabCursor: function () {
					var e = this
					e.support.touch ||
						(e.params.watchOverflow && e.isLocked) ||
						e.params.cssMode ||
						(e.el.style.cursor = "")
				},
			}
			const V = {
				appendSlide: function (e) {
					var t = this,
						i = t.$wrapperEl,
						n = t.params
					if ((n.loop && t.loopDestroy(), "object" == typeof e && "length" in e))
						for (var s = 0; s < e.length; s += 1) e[s] && i.append(e[s])
					else i.append(e)
					;(n.loop && t.loopCreate(), (n.observer && t.support.observer) || t.update())
				},
				prependSlide: function (e) {
					var t = this,
						i = t.params,
						n = t.$wrapperEl,
						s = t.activeIndex
					i.loop && t.loopDestroy()
					var r = s + 1
					if ("object" == typeof e && "length" in e) {
						for (var a = 0; a < e.length; a += 1) e[a] && n.prepend(e[a])
						r = s + e.length
					} else n.prepend(e)
					;(i.loop && t.loopCreate(),
						(i.observer && t.support.observer) || t.update(),
						t.slideTo(r, 0, !1))
				},
				addSlide: function (e, t) {
					var i = this,
						n = i.$wrapperEl,
						s = i.params,
						r = i.activeIndex
					s.loop &&
						((r -= i.loopedSlides), i.loopDestroy(), (i.slides = n.children("." + s.slideClass)))
					var a = i.slides.length
					if (e <= 0) i.prependSlide(t)
					else if (e >= a) i.appendSlide(t)
					else {
						for (var o = r > e ? r + 1 : r, l = [], d = a - 1; d >= e; d -= 1) {
							var c = i.slides.eq(d)
							;(c.remove(), l.unshift(c))
						}
						if ("object" == typeof t && "length" in t) {
							for (var u = 0; u < t.length; u += 1) t[u] && n.append(t[u])
							o = r > e ? r + t.length : r
						} else n.append(t)
						for (var p = 0; p < l.length; p += 1) n.append(l[p])
						;(s.loop && i.loopCreate(),
							(s.observer && i.support.observer) || i.update(),
							s.loop ? i.slideTo(o + i.loopedSlides, 0, !1) : i.slideTo(o, 0, !1))
					}
				},
				removeSlide: function (e) {
					var t = this,
						i = t.params,
						n = t.$wrapperEl,
						s = t.activeIndex
					i.loop &&
						((s -= t.loopedSlides), t.loopDestroy(), (t.slides = n.children("." + i.slideClass)))
					var r,
						a = s
					if ("object" == typeof e && "length" in e) {
						for (var o = 0; o < e.length; o += 1)
							((r = e[o]), t.slides[r] && t.slides.eq(r).remove(), r < a && (a -= 1))
						a = Math.max(a, 0)
					} else
						((r = e),
							t.slides[r] && t.slides.eq(r).remove(),
							r < a && (a -= 1),
							(a = Math.max(a, 0)))
					;(i.loop && t.loopCreate(),
						(i.observer && t.support.observer) || t.update(),
						i.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1))
				},
				removeAllSlides: function () {
					for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t)
					this.removeSlide(e)
				},
			}
			function q(e) {
				var t = this,
					i = s(),
					n = a(),
					r = t.touchEventsData,
					o = t.params,
					l = t.touches
				if (t.enabled && (!t.animating || !o.preventInteractionOnTransition)) {
					var d = e
					d.originalEvent && (d = d.originalEvent)
					var c = y(d.target)
					if (
						("wrapper" !== o.touchEventsTarget || c.closest(t.wrapperEl).length) &&
						((r.isTouchEvent = "touchstart" === d.type),
						(r.isTouchEvent || !("which" in d) || 3 !== d.which) &&
							!((!r.isTouchEvent && "button" in d && d.button > 0) || (r.isTouched && r.isMoved)))
					) {
						!!o.noSwipingClass &&
							"" !== o.noSwipingClass &&
							d.target &&
							d.target.shadowRoot &&
							e.path &&
							e.path[0] &&
							(c = y(e.path[0]))
						var u = o.noSwipingSelector ? o.noSwipingSelector : "." + o.noSwipingClass,
							p = !(!d.target || !d.target.shadowRoot)
						if (
							o.noSwiping &&
							(p
								? (function (e, t) {
										return (
											void 0 === t && (t = this),
											(function t(i) {
												return i && i !== s() && i !== a()
													? (i.assignedSlot && (i = i.assignedSlot),
														i.closest(e) || t(i.getRootNode().host))
													: null
											})(t)
										)
									})(u, d.target)
								: c.closest(u)[0])
						)
							t.allowClick = !0
						else if (!o.swipeHandler || c.closest(o.swipeHandler)[0]) {
							;((l.currentX = "touchstart" === d.type ? d.targetTouches[0].pageX : d.pageX),
								(l.currentY = "touchstart" === d.type ? d.targetTouches[0].pageY : d.pageY))
							var h = l.currentX,
								f = l.currentY,
								v = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
								m = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold
							if (v && (h <= m || h >= n.innerWidth - m)) {
								if ("prevent" !== v) return
								e.preventDefault()
							}
							if (
								(S(r, {
									isTouched: !0,
									isMoved: !1,
									allowTouchCallbacks: !0,
									isScrolling: void 0,
									startMoving: void 0,
								}),
								(l.startX = h),
								(l.startY = f),
								(r.touchStartTime = w()),
								(t.allowClick = !0),
								t.updateSize(),
								(t.swipeDirection = void 0),
								o.threshold > 0 && (r.allowThresholdMove = !1),
								"touchstart" !== d.type)
							) {
								var g = !0
								;(c.is(r.focusableElements) && (g = !1),
									i.activeElement &&
										y(i.activeElement).is(r.focusableElements) &&
										i.activeElement !== c[0] &&
										i.activeElement.blur())
								var b = g && t.allowTouchMove && o.touchStartPreventDefault
								;(!o.touchStartForcePreventDefault && !b) ||
									c[0].isContentEditable ||
									d.preventDefault()
							}
							t.emit("touchStart", d)
						}
					}
				}
			}
			function R(e) {
				var t = s(),
					i = this,
					n = i.touchEventsData,
					r = i.params,
					a = i.touches,
					o = i.rtlTranslate
				if (i.enabled) {
					var l = e
					if ((l.originalEvent && (l = l.originalEvent), n.isTouched)) {
						if (!n.isTouchEvent || "touchmove" === l.type) {
							var d =
									"touchmove" === l.type &&
									l.targetTouches &&
									(l.targetTouches[0] || l.changedTouches[0]),
								c = "touchmove" === l.type ? d.pageX : l.pageX,
								u = "touchmove" === l.type ? d.pageY : l.pageY
							if (l.preventedByNestedSwiper) return ((a.startX = c), void (a.startY = u))
							if (!i.allowTouchMove)
								return (
									(i.allowClick = !1),
									void (
										n.isTouched &&
										(S(a, { startX: c, startY: u, currentX: c, currentY: u }),
										(n.touchStartTime = w()))
									)
								)
							if (n.isTouchEvent && r.touchReleaseOnEdges && !r.loop)
								if (i.isVertical()) {
									if (
										(u < a.startY && i.translate <= i.maxTranslate()) ||
										(u > a.startY && i.translate >= i.minTranslate())
									)
										return ((n.isTouched = !1), void (n.isMoved = !1))
								} else if (
									(c < a.startX && i.translate <= i.maxTranslate()) ||
									(c > a.startX && i.translate >= i.minTranslate())
								)
									return
							if (
								n.isTouchEvent &&
								t.activeElement &&
								l.target === t.activeElement &&
								y(l.target).is(n.focusableElements)
							)
								return ((n.isMoved = !0), void (i.allowClick = !1))
							if (
								(n.allowTouchCallbacks && i.emit("touchMove", l),
								!(l.targetTouches && l.targetTouches.length > 1))
							) {
								;((a.currentX = c), (a.currentY = u))
								var p = a.currentX - a.startX,
									h = a.currentY - a.startY
								if (
									!(
										i.params.threshold &&
										Math.sqrt(Math.pow(p, 2) + Math.pow(h, 2)) < i.params.threshold
									)
								) {
									var f
									if (void 0 === n.isScrolling)
										(i.isHorizontal() && a.currentY === a.startY) ||
										(i.isVertical() && a.currentX === a.startX)
											? (n.isScrolling = !1)
											: p * p + h * h >= 25 &&
												((f = (180 * Math.atan2(Math.abs(h), Math.abs(p))) / Math.PI),
												(n.isScrolling = i.isHorizontal()
													? f > r.touchAngle
													: 90 - f > r.touchAngle))
									if (
										(n.isScrolling && i.emit("touchMoveOpposite", l),
										void 0 === n.startMoving &&
											((a.currentX === a.startX && a.currentY === a.startY) ||
												(n.startMoving = !0)),
										n.isScrolling)
									)
										n.isTouched = !1
									else if (n.startMoving) {
										;((i.allowClick = !1),
											!r.cssMode && l.cancelable && l.preventDefault(),
											r.touchMoveStopPropagation && !r.nested && l.stopPropagation(),
											n.isMoved ||
												(r.loop && i.loopFix(),
												(n.startTranslate = i.getTranslate()),
												i.setTransition(0),
												i.animating && i.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
												(n.allowMomentumBounce = !1),
												!r.grabCursor ||
													(!0 !== i.allowSlideNext && !0 !== i.allowSlidePrev) ||
													i.setGrabCursor(!0),
												i.emit("sliderFirstMove", l)),
											i.emit("sliderMove", l),
											(n.isMoved = !0))
										var v = i.isHorizontal() ? p : h
										;((a.diff = v),
											(v *= r.touchRatio),
											o && (v = -v),
											(i.swipeDirection = v > 0 ? "prev" : "next"),
											(n.currentTranslate = v + n.startTranslate))
										var m = !0,
											g = r.resistanceRatio
										if (
											(r.touchReleaseOnEdges && (g = 0),
											v > 0 && n.currentTranslate > i.minTranslate()
												? ((m = !1),
													r.resistance &&
														(n.currentTranslate =
															i.minTranslate() -
															1 +
															Math.pow(-i.minTranslate() + n.startTranslate + v, g)))
												: v < 0 &&
													n.currentTranslate < i.maxTranslate() &&
													((m = !1),
													r.resistance &&
														(n.currentTranslate =
															i.maxTranslate() +
															1 -
															Math.pow(i.maxTranslate() - n.startTranslate - v, g))),
											m && (l.preventedByNestedSwiper = !0),
											!i.allowSlideNext &&
												"next" === i.swipeDirection &&
												n.currentTranslate < n.startTranslate &&
												(n.currentTranslate = n.startTranslate),
											!i.allowSlidePrev &&
												"prev" === i.swipeDirection &&
												n.currentTranslate > n.startTranslate &&
												(n.currentTranslate = n.startTranslate),
											i.allowSlidePrev ||
												i.allowSlideNext ||
												(n.currentTranslate = n.startTranslate),
											r.threshold > 0)
										) {
											if (!(Math.abs(v) > r.threshold || n.allowThresholdMove))
												return void (n.currentTranslate = n.startTranslate)
											if (!n.allowThresholdMove)
												return (
													(n.allowThresholdMove = !0),
													(a.startX = a.currentX),
													(a.startY = a.currentY),
													(n.currentTranslate = n.startTranslate),
													void (a.diff = i.isHorizontal()
														? a.currentX - a.startX
														: a.currentY - a.startY)
												)
										}
										r.followFinger &&
											!r.cssMode &&
											((r.freeMode || r.watchSlidesProgress || r.watchSlidesVisibility) &&
												(i.updateActiveIndex(), i.updateSlidesClasses()),
											r.freeMode &&
												(0 === n.velocities.length &&
													n.velocities.push({
														position: a[i.isHorizontal() ? "startX" : "startY"],
														time: n.touchStartTime,
													}),
												n.velocities.push({
													position: a[i.isHorizontal() ? "currentX" : "currentY"],
													time: w(),
												})),
											i.updateProgress(n.currentTranslate),
											i.setTranslate(n.currentTranslate))
									}
								}
							}
						}
					} else n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", l)
				}
			}
			function X(e) {
				var t = this,
					i = t.touchEventsData,
					n = t.params,
					s = t.touches,
					r = t.rtlTranslate,
					a = t.$wrapperEl,
					o = t.slidesGrid,
					l = t.snapGrid
				if (t.enabled) {
					var d = e
					if (
						(d.originalEvent && (d = d.originalEvent),
						i.allowTouchCallbacks && t.emit("touchEnd", d),
						(i.allowTouchCallbacks = !1),
						!i.isTouched)
					)
						return (
							i.isMoved && n.grabCursor && t.setGrabCursor(!1),
							(i.isMoved = !1),
							void (i.startMoving = !1)
						)
					n.grabCursor &&
						i.isMoved &&
						i.isTouched &&
						(!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
						t.setGrabCursor(!1)
					var c,
						u = w(),
						p = u - i.touchStartTime
					if (
						(t.allowClick &&
							(t.updateClickedSlide(d),
							t.emit("tap click", d),
							p < 300 && u - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", d)),
						(i.lastClickTime = w()),
						b(function () {
							t.destroyed || (t.allowClick = !0)
						}),
						!i.isTouched ||
							!i.isMoved ||
							!t.swipeDirection ||
							0 === s.diff ||
							i.currentTranslate === i.startTranslate)
					)
						return ((i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1))
					if (
						((i.isTouched = !1),
						(i.isMoved = !1),
						(i.startMoving = !1),
						(c = n.followFinger ? (r ? t.translate : -t.translate) : -i.currentTranslate),
						!n.cssMode)
					)
						if (n.freeMode) {
							if (c < -t.minTranslate()) return void t.slideTo(t.activeIndex)
							if (c > -t.maxTranslate())
								return void (t.slides.length < l.length
									? t.slideTo(l.length - 1)
									: t.slideTo(t.slides.length - 1))
							if (n.freeModeMomentum) {
								if (i.velocities.length > 1) {
									var h = i.velocities.pop(),
										f = i.velocities.pop(),
										v = h.position - f.position,
										m = h.time - f.time
									;((t.velocity = v / m),
										(t.velocity /= 2),
										Math.abs(t.velocity) < n.freeModeMinimumVelocity && (t.velocity = 0),
										(m > 150 || w() - h.time > 300) && (t.velocity = 0))
								} else t.velocity = 0
								;((t.velocity *= n.freeModeMomentumVelocityRatio), (i.velocities.length = 0))
								var g = 1e3 * n.freeModeMomentumRatio,
									y = t.velocity * g,
									C = t.translate + y
								r && (C = -C)
								var T,
									S,
									E = !1,
									x = 20 * Math.abs(t.velocity) * n.freeModeMomentumBounceRatio
								if (C < t.maxTranslate())
									(n.freeModeMomentumBounce
										? (C + t.maxTranslate() < -x && (C = t.maxTranslate() - x),
											(T = t.maxTranslate()),
											(E = !0),
											(i.allowMomentumBounce = !0))
										: (C = t.maxTranslate()),
										n.loop && n.centeredSlides && (S = !0))
								else if (C > t.minTranslate())
									(n.freeModeMomentumBounce
										? (C - t.minTranslate() > x && (C = t.minTranslate() + x),
											(T = t.minTranslate()),
											(E = !0),
											(i.allowMomentumBounce = !0))
										: (C = t.minTranslate()),
										n.loop && n.centeredSlides && (S = !0))
								else if (n.freeModeSticky) {
									for (var M, k = 0; k < l.length; k += 1)
										if (l[k] > -C) {
											M = k
											break
										}
									C = -(C =
										Math.abs(l[M] - C) < Math.abs(l[M - 1] - C) || "next" === t.swipeDirection
											? l[M]
											: l[M - 1])
								}
								if (
									(S &&
										t.once("transitionEnd", function () {
											t.loopFix()
										}),
									0 !== t.velocity)
								) {
									if (
										((g = r
											? Math.abs((-C - t.translate) / t.velocity)
											: Math.abs((C - t.translate) / t.velocity)),
										n.freeModeSticky)
									) {
										var O = Math.abs((r ? -C : C) - t.translate),
											P = t.slidesSizesGrid[t.activeIndex]
										g = O < P ? n.speed : O < 2 * P ? 1.5 * n.speed : 2.5 * n.speed
									}
								} else if (n.freeModeSticky) return void t.slideToClosest()
								;(n.freeModeMomentumBounce && E
									? (t.updateProgress(T),
										t.setTransition(g),
										t.setTranslate(C),
										t.transitionStart(!0, t.swipeDirection),
										(t.animating = !0),
										a.transitionEnd(function () {
											t &&
												!t.destroyed &&
												i.allowMomentumBounce &&
												(t.emit("momentumBounce"),
												t.setTransition(n.speed),
												setTimeout(function () {
													;(t.setTranslate(T),
														a.transitionEnd(function () {
															t && !t.destroyed && t.transitionEnd()
														}))
												}, 0))
										}))
									: t.velocity
										? (t.updateProgress(C),
											t.setTransition(g),
											t.setTranslate(C),
											t.transitionStart(!0, t.swipeDirection),
											t.animating ||
												((t.animating = !0),
												a.transitionEnd(function () {
													t && !t.destroyed && t.transitionEnd()
												})))
										: (t.emit("_freeModeNoMomentumRelease"), t.updateProgress(C)),
									t.updateActiveIndex(),
									t.updateSlidesClasses())
							} else {
								if (n.freeModeSticky) return void t.slideToClosest()
								n.freeMode && t.emit("_freeModeNoMomentumRelease")
							}
							;(!n.freeModeMomentum || p >= n.longSwipesMs) &&
								(t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
						} else {
							for (
								var L = 0, A = t.slidesSizesGrid[0], z = 0;
								z < o.length;
								z += z < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup
							) {
								var I = z < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup
								void 0 !== o[z + I]
									? c >= o[z] && c < o[z + I] && ((L = z), (A = o[z + I] - o[z]))
									: c >= o[z] && ((L = z), (A = o[o.length - 1] - o[o.length - 2]))
							}
							var D = (c - o[L]) / A,
								B = L < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup
							if (p > n.longSwipesMs) {
								if (!n.longSwipes) return void t.slideTo(t.activeIndex)
								;("next" === t.swipeDirection &&
									(D >= n.longSwipesRatio ? t.slideTo(L + B) : t.slideTo(L)),
									"prev" === t.swipeDirection &&
										(D > 1 - n.longSwipesRatio ? t.slideTo(L + B) : t.slideTo(L)))
							} else {
								if (!n.shortSwipes) return void t.slideTo(t.activeIndex)
								t.navigation &&
								(d.target === t.navigation.nextEl || d.target === t.navigation.prevEl)
									? d.target === t.navigation.nextEl
										? t.slideTo(L + B)
										: t.slideTo(L)
									: ("next" === t.swipeDirection && t.slideTo(L + B),
										"prev" === t.swipeDirection && t.slideTo(L))
							}
						}
				}
			}
			function Y() {
				var e = this,
					t = e.params,
					i = e.el
				if (!i || 0 !== i.offsetWidth) {
					t.breakpoints && e.setBreakpoint()
					var n = e.allowSlideNext,
						s = e.allowSlidePrev,
						r = e.snapGrid
					;((e.allowSlideNext = !0),
						(e.allowSlidePrev = !0),
						e.updateSize(),
						e.updateSlides(),
						e.updateSlidesClasses(),
						("auto" === t.slidesPerView || t.slidesPerView > 1) &&
						e.isEnd &&
						!e.isBeginning &&
						!e.params.centeredSlides
							? e.slideTo(e.slides.length - 1, 0, !1, !0)
							: e.slideTo(e.activeIndex, 0, !1, !0),
						e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
						(e.allowSlidePrev = s),
						(e.allowSlideNext = n),
						e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow())
				}
			}
			function U(e) {
				var t = this
				t.enabled &&
					(t.allowClick ||
						(t.params.preventClicks && e.preventDefault(),
						t.params.preventClicksPropagation &&
							t.animating &&
							(e.stopPropagation(), e.stopImmediatePropagation())))
			}
			function K() {
				var e = this,
					t = e.wrapperEl,
					i = e.rtlTranslate
				if (e.enabled) {
					;((e.previousTranslate = e.translate),
						e.isHorizontal()
							? (e.translate = i ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft)
							: (e.translate = -t.scrollTop),
						-0 === e.translate && (e.translate = 0),
						e.updateActiveIndex(),
						e.updateSlidesClasses())
					var n = e.maxTranslate() - e.minTranslate()
					;((0 === n ? 0 : (e.translate - e.minTranslate()) / n) !== e.progress &&
						e.updateProgress(i ? -e.translate : e.translate),
						e.emit("setTranslate", e.translate, !1))
				}
			}
			var Z = !1
			function J() {}
			const Q = {
				attachEvents: function () {
					var e = this,
						t = s(),
						i = e.params,
						n = e.touchEvents,
						r = e.el,
						a = e.wrapperEl,
						o = e.device,
						l = e.support
					;((e.onTouchStart = q.bind(e)),
						(e.onTouchMove = R.bind(e)),
						(e.onTouchEnd = X.bind(e)),
						i.cssMode && (e.onScroll = K.bind(e)),
						(e.onClick = U.bind(e)))
					var d = !!i.nested
					if (!l.touch && l.pointerEvents)
						(r.addEventListener(n.start, e.onTouchStart, !1),
							t.addEventListener(n.move, e.onTouchMove, d),
							t.addEventListener(n.end, e.onTouchEnd, !1))
					else {
						if (l.touch) {
							var c = !("touchstart" !== n.start || !l.passiveListener || !i.passiveListeners) && {
								passive: !0,
								capture: !1,
							}
							;(r.addEventListener(n.start, e.onTouchStart, c),
								r.addEventListener(
									n.move,
									e.onTouchMove,
									l.passiveListener ? { passive: !1, capture: d } : d,
								),
								r.addEventListener(n.end, e.onTouchEnd, c),
								n.cancel && r.addEventListener(n.cancel, e.onTouchEnd, c),
								Z || (t.addEventListener("touchstart", J), (Z = !0)))
						}
						;((i.simulateTouch && !o.ios && !o.android) ||
							(i.simulateTouch && !l.touch && o.ios)) &&
							(r.addEventListener("mousedown", e.onTouchStart, !1),
							t.addEventListener("mousemove", e.onTouchMove, d),
							t.addEventListener("mouseup", e.onTouchEnd, !1))
					}
					;((i.preventClicks || i.preventClicksPropagation) &&
						r.addEventListener("click", e.onClick, !0),
						i.cssMode && a.addEventListener("scroll", e.onScroll),
						i.updateOnWindowResize
							? e.on(
									o.ios || o.android
										? "resize orientationchange observerUpdate"
										: "resize observerUpdate",
									Y,
									!0,
								)
							: e.on("observerUpdate", Y, !0))
				},
				detachEvents: function () {
					var e = this,
						t = s(),
						i = e.params,
						n = e.touchEvents,
						r = e.el,
						a = e.wrapperEl,
						o = e.device,
						l = e.support,
						d = !!i.nested
					if (!l.touch && l.pointerEvents)
						(r.removeEventListener(n.start, e.onTouchStart, !1),
							t.removeEventListener(n.move, e.onTouchMove, d),
							t.removeEventListener(n.end, e.onTouchEnd, !1))
					else {
						if (l.touch) {
							var c = !(
								"onTouchStart" !== n.start ||
								!l.passiveListener ||
								!i.passiveListeners
							) && { passive: !0, capture: !1 }
							;(r.removeEventListener(n.start, e.onTouchStart, c),
								r.removeEventListener(n.move, e.onTouchMove, d),
								r.removeEventListener(n.end, e.onTouchEnd, c),
								n.cancel && r.removeEventListener(n.cancel, e.onTouchEnd, c))
						}
						;((i.simulateTouch && !o.ios && !o.android) ||
							(i.simulateTouch && !l.touch && o.ios)) &&
							(r.removeEventListener("mousedown", e.onTouchStart, !1),
							t.removeEventListener("mousemove", e.onTouchMove, d),
							t.removeEventListener("mouseup", e.onTouchEnd, !1))
					}
					;((i.preventClicks || i.preventClicksPropagation) &&
						r.removeEventListener("click", e.onClick, !0),
						i.cssMode && a.removeEventListener("scroll", e.onScroll),
						e.off(
							o.ios || o.android
								? "resize orientationchange observerUpdate"
								: "resize observerUpdate",
							Y,
						))
				},
			}
			const ee = {
				setBreakpoint: function () {
					var e = this,
						t = e.activeIndex,
						i = e.initialized,
						n = e.loopedSlides,
						s = void 0 === n ? 0 : n,
						r = e.params,
						a = e.$el,
						o = r.breakpoints
					if (o && (!o || 0 !== Object.keys(o).length)) {
						var l = e.getBreakpoint(o, e.params.breakpointsBase, e.el)
						if (l && e.currentBreakpoint !== l) {
							var d = l in o ? o[l] : void 0
							d &&
								[
									"slidesPerView",
									"spaceBetween",
									"slidesPerGroup",
									"slidesPerGroupSkip",
									"slidesPerColumn",
								].forEach(function (e) {
									var t = d[e]
									void 0 !== t &&
										(d[e] =
											"slidesPerView" !== e || ("AUTO" !== t && "auto" !== t)
												? "slidesPerView" === e
													? parseFloat(t)
													: parseInt(t, 10)
												: "auto")
								})
							var c = d || e.originalParams,
								u = r.slidesPerColumn > 1,
								p = c.slidesPerColumn > 1,
								h = r.enabled
							u && !p
								? (a.removeClass(
										r.containerModifierClass +
											"multirow " +
											r.containerModifierClass +
											"multirow-column",
									),
									e.emitContainerClasses())
								: !u &&
									p &&
									(a.addClass(r.containerModifierClass + "multirow"),
									((c.slidesPerColumnFill && "column" === c.slidesPerColumnFill) ||
										(!c.slidesPerColumnFill && "column" === r.slidesPerColumnFill)) &&
										a.addClass(r.containerModifierClass + "multirow-column"),
									e.emitContainerClasses())
							var f = c.direction && c.direction !== r.direction,
								v = r.loop && (c.slidesPerView !== r.slidesPerView || f)
							;(f && i && e.changeDirection(), S(e.params, c))
							var m = e.params.enabled
							;(S(e, {
								allowTouchMove: e.params.allowTouchMove,
								allowSlideNext: e.params.allowSlideNext,
								allowSlidePrev: e.params.allowSlidePrev,
							}),
								h && !m ? e.disable() : !h && m && e.enable(),
								(e.currentBreakpoint = l),
								e.emit("_beforeBreakpoint", c),
								v &&
									i &&
									(e.loopDestroy(),
									e.loopCreate(),
									e.updateSlides(),
									e.slideTo(t - s + e.loopedSlides, 0, !1)),
								e.emit("breakpoint", c))
						}
					}
				},
				getBreakpoint: function (e, t, i) {
					if ((void 0 === t && (t = "window"), e && ("container" !== t || i))) {
						var n = !1,
							s = a(),
							r = "window" === t ? s.innerHeight : i.clientHeight,
							o = Object.keys(e).map(function (e) {
								if ("string" == typeof e && 0 === e.indexOf("@")) {
									var t = parseFloat(e.substr(1))
									return { value: r * t, point: e }
								}
								return { value: e, point: e }
							})
						o.sort(function (e, t) {
							return parseInt(e.value, 10) - parseInt(t.value, 10)
						})
						for (var l = 0; l < o.length; l += 1) {
							var d = o[l],
								c = d.point,
								u = d.value
							"window" === t
								? s.matchMedia("(min-width: " + u + "px)").matches && (n = c)
								: u <= i.clientWidth && (n = c)
						}
						return n || "max"
					}
				},
			}
			const te = {
				addClasses: function () {
					var e,
						t,
						i,
						n = this,
						s = n.classNames,
						r = n.params,
						a = n.rtl,
						o = n.$el,
						l = n.device,
						d = n.support,
						c =
							((e = [
								"initialized",
								r.direction,
								{ "pointer-events": d.pointerEvents && !d.touch },
								{ "free-mode": r.freeMode },
								{ autoheight: r.autoHeight },
								{ rtl: a },
								{ multirow: r.slidesPerColumn > 1 },
								{ "multirow-column": r.slidesPerColumn > 1 && "column" === r.slidesPerColumnFill },
								{ android: l.android },
								{ ios: l.ios },
								{ "css-mode": r.cssMode },
							]),
							(t = r.containerModifierClass),
							(i = []),
							e.forEach(function (e) {
								"object" == typeof e
									? Object.keys(e).forEach(function (n) {
											e[n] && i.push(t + n)
										})
									: "string" == typeof e && i.push(t + e)
							}),
							i)
					;(s.push.apply(s, c), o.addClass([].concat(s).join(" ")), n.emitContainerClasses())
				},
				removeClasses: function () {
					var e = this,
						t = e.$el,
						i = e.classNames
					;(t.removeClass(i.join(" ")), e.emitContainerClasses())
				},
			}
			const ie = {
				loadImage: function (e, t, i, n, s, r) {
					var o,
						l = a()
					function d() {
						r && r()
					}
					y(e).parent("picture")[0] || (e.complete && s)
						? d()
						: t
							? (((o = new l.Image()).onload = d),
								(o.onerror = d),
								n && (o.sizes = n),
								i && (o.srcset = i),
								t && (o.src = t))
							: d()
				},
				preloadImages: function () {
					var e = this
					function t() {
						null != e &&
							e &&
							!e.destroyed &&
							(void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
							e.imagesLoaded === e.imagesToLoad.length &&
								(e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")))
					}
					e.imagesToLoad = e.$el.find("img")
					for (var i = 0; i < e.imagesToLoad.length; i += 1) {
						var n = e.imagesToLoad[i]
						e.loadImage(
							n,
							n.currentSrc || n.getAttribute("src"),
							n.srcset || n.getAttribute("srcset"),
							n.sizes || n.getAttribute("sizes"),
							!0,
							t,
						)
					}
				},
			}
			const ne = {
					checkOverflow: function () {
						var e = this,
							t = e.params,
							i = e.isLocked,
							n =
								e.slides.length > 0 &&
								t.slidesOffsetBefore +
									t.spaceBetween * (e.slides.length - 1) +
									e.slides[0].offsetWidth * e.slides.length
						;(t.slidesOffsetBefore && t.slidesOffsetAfter && n
							? (e.isLocked = n <= e.size)
							: (e.isLocked = 1 === e.snapGrid.length),
							(e.allowSlideNext = !e.isLocked),
							(e.allowSlidePrev = !e.isLocked),
							i !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
							i && i !== e.isLocked && ((e.isEnd = !1), e.navigation && e.navigation.update()))
					},
				},
				se = {
					init: !0,
					direction: "horizontal",
					touchEventsTarget: "container",
					initialSlide: 0,
					speed: 300,
					cssMode: !1,
					updateOnWindowResize: !0,
					resizeObserver: !1,
					nested: !1,
					createElements: !1,
					enabled: !0,
					focusableElements: "input, select, option, textarea, button, video, label",
					width: null,
					height: null,
					preventInteractionOnTransition: !1,
					userAgent: null,
					url: null,
					edgeSwipeDetection: !1,
					edgeSwipeThreshold: 20,
					freeMode: !1,
					freeModeMomentum: !0,
					freeModeMomentumRatio: 1,
					freeModeMomentumBounce: !0,
					freeModeMomentumBounceRatio: 1,
					freeModeMomentumVelocityRatio: 1,
					freeModeSticky: !1,
					freeModeMinimumVelocity: 0.02,
					autoHeight: !1,
					setWrapperSize: !1,
					virtualTranslate: !1,
					effect: "slide",
					breakpoints: void 0,
					breakpointsBase: "window",
					spaceBetween: 0,
					slidesPerView: 1,
					slidesPerColumn: 1,
					slidesPerColumnFill: "column",
					slidesPerGroup: 1,
					slidesPerGroupSkip: 0,
					centeredSlides: !1,
					centeredSlidesBounds: !1,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0,
					normalizeSlideIndex: !0,
					centerInsufficientSlides: !1,
					watchOverflow: !1,
					roundLengths: !1,
					touchRatio: 1,
					touchAngle: 45,
					simulateTouch: !0,
					shortSwipes: !0,
					longSwipes: !0,
					longSwipesRatio: 0.5,
					longSwipesMs: 300,
					followFinger: !0,
					allowTouchMove: !0,
					threshold: 0,
					touchMoveStopPropagation: !1,
					touchStartPreventDefault: !0,
					touchStartForcePreventDefault: !1,
					touchReleaseOnEdges: !1,
					uniqueNavElements: !0,
					resistance: !0,
					resistanceRatio: 0.85,
					watchSlidesProgress: !1,
					watchSlidesVisibility: !1,
					grabCursor: !1,
					preventClicks: !0,
					preventClicksPropagation: !0,
					slideToClickedSlide: !1,
					preloadImages: !0,
					updateOnImagesReady: !0,
					loop: !1,
					loopAdditionalSlides: 0,
					loopedSlides: null,
					loopFillGroupWithBlank: !1,
					loopPreventsSlide: !0,
					allowSlidePrev: !0,
					allowSlideNext: !0,
					swipeHandler: null,
					noSwiping: !0,
					noSwipingClass: "swiper-no-swiping",
					noSwipingSelector: null,
					passiveListeners: !0,
					containerModifierClass: "swiper-container-",
					slideClass: "swiper-slide",
					slideBlankClass: "swiper-slide-invisible-blank",
					slideActiveClass: "swiper-slide-active",
					slideDuplicateActiveClass: "swiper-slide-duplicate-active",
					slideVisibleClass: "swiper-slide-visible",
					slideDuplicateClass: "swiper-slide-duplicate",
					slideNextClass: "swiper-slide-next",
					slideDuplicateNextClass: "swiper-slide-duplicate-next",
					slidePrevClass: "swiper-slide-prev",
					slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
					wrapperClass: "swiper-wrapper",
					runCallbacksOnInit: !0,
					_emitClasses: !1,
				}
			function re(e, t) {
				for (var i = 0; i < t.length; i++) {
					var n = t[i]
					;((n.enumerable = n.enumerable || !1),
						(n.configurable = !0),
						"value" in n && (n.writable = !0),
						Object.defineProperty(e, n.key, n))
				}
			}
			var ae = {
					modular: {
						useParams: function (e) {
							var t = this
							t.modules &&
								Object.keys(t.modules).forEach(function (i) {
									var n = t.modules[i]
									n.params && S(e, n.params)
								})
						},
						useModules: function (e) {
							void 0 === e && (e = {})
							var t = this
							t.modules &&
								Object.keys(t.modules).forEach(function (i) {
									var n = t.modules[i],
										s = e[i] || {}
									;(n.on &&
										t.on &&
										Object.keys(n.on).forEach(function (e) {
											t.on(e, n.on[e])
										}),
										n.create && n.create.bind(t)(s))
								})
						},
					},
					eventsEmitter: j,
					update: $,
					translate: _,
					transition: H,
					slide: G,
					loop: F,
					grabCursor: W,
					manipulation: V,
					events: Q,
					breakpoints: ee,
					checkOverflow: ne,
					classes: te,
					images: ie,
				},
				oe = {},
				le = (function () {
					function e() {
						for (var t, i, n = arguments.length, s = new Array(n), r = 0; r < n; r++)
							s[r] = arguments[r]
						if (
							(1 === s.length &&
							s[0].constructor &&
							"Object" === Object.prototype.toString.call(s[0]).slice(8, -1)
								? (i = s[0])
								: ((t = s[0]), (i = s[1])),
							i || (i = {}),
							(i = S({}, i)),
							t && !i.el && (i.el = t),
							i.el && y(i.el).length > 1)
						) {
							var a = []
							return (
								y(i.el).each(function (t) {
									var n = S({}, i, { el: t })
									a.push(new e(n))
								}),
								a
							)
						}
						var o = this
						;((o.__swiper__ = !0),
							(o.support = L()),
							(o.device = A({ userAgent: i.userAgent })),
							(o.browser = z()),
							(o.eventsListeners = {}),
							(o.eventsAnyListeners = []),
							void 0 === o.modules && (o.modules = {}),
							Object.keys(o.modules).forEach(function (e) {
								var t = o.modules[e]
								if (t.params) {
									var n = Object.keys(t.params)[0],
										s = t.params[n]
									if ("object" != typeof s || null === s) return
									if (
										(["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 &&
											!0 === i[n] &&
											(i[n] = { auto: !0 }),
										!(n in i) || !("enabled" in s))
									)
										return
									;(!0 === i[n] && (i[n] = { enabled: !0 }),
										"object" != typeof i[n] || "enabled" in i[n] || (i[n].enabled = !0),
										i[n] || (i[n] = { enabled: !1 }))
								}
							}))
						var l,
							d,
							c = S({}, se)
						return (
							o.useParams(c),
							(o.params = S({}, c, oe, i)),
							(o.originalParams = S({}, o.params)),
							(o.passedParams = S({}, i)),
							o.params &&
								o.params.on &&
								Object.keys(o.params.on).forEach(function (e) {
									o.on(e, o.params.on[e])
								}),
							o.params && o.params.onAny && o.onAny(o.params.onAny),
							(o.$ = y),
							S(o, {
								enabled: o.params.enabled,
								el: t,
								classNames: [],
								slides: y(),
								slidesGrid: [],
								snapGrid: [],
								slidesSizesGrid: [],
								isHorizontal: function () {
									return "horizontal" === o.params.direction
								},
								isVertical: function () {
									return "vertical" === o.params.direction
								},
								activeIndex: 0,
								realIndex: 0,
								isBeginning: !0,
								isEnd: !1,
								translate: 0,
								previousTranslate: 0,
								progress: 0,
								velocity: 0,
								animating: !1,
								allowSlideNext: o.params.allowSlideNext,
								allowSlidePrev: o.params.allowSlidePrev,
								touchEvents:
									((l = ["touchstart", "touchmove", "touchend", "touchcancel"]),
									(d = ["mousedown", "mousemove", "mouseup"]),
									o.support.pointerEvents && (d = ["pointerdown", "pointermove", "pointerup"]),
									(o.touchEventsTouch = { start: l[0], move: l[1], end: l[2], cancel: l[3] }),
									(o.touchEventsDesktop = { start: d[0], move: d[1], end: d[2] }),
									o.support.touch || !o.params.simulateTouch
										? o.touchEventsTouch
										: o.touchEventsDesktop),
								touchEventsData: {
									isTouched: void 0,
									isMoved: void 0,
									allowTouchCallbacks: void 0,
									touchStartTime: void 0,
									isScrolling: void 0,
									currentTranslate: void 0,
									startTranslate: void 0,
									allowThresholdMove: void 0,
									focusableElements: o.params.focusableElements,
									lastClickTime: w(),
									clickTimeout: void 0,
									velocities: [],
									allowMomentumBounce: void 0,
									isTouchEvent: void 0,
									startMoving: void 0,
								},
								allowClick: !0,
								allowTouchMove: o.params.allowTouchMove,
								touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
								imagesToLoad: [],
								imagesLoaded: 0,
							}),
							o.useModules(),
							o.emit("_swiper"),
							o.params.init && o.init(),
							o
						)
					}
					var t,
						i,
						n,
						r = e.prototype
					return (
						(r.enable = function () {
							var e = this
							e.enabled ||
								((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"))
						}),
						(r.disable = function () {
							var e = this
							e.enabled &&
								((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"))
						}),
						(r.setProgress = function (e, t) {
							var i = this
							e = Math.min(Math.max(e, 0), 1)
							var n = i.minTranslate(),
								s = (i.maxTranslate() - n) * e + n
							;(i.translateTo(s, void 0 === t ? 0 : t),
								i.updateActiveIndex(),
								i.updateSlidesClasses())
						}),
						(r.emitContainerClasses = function () {
							var e = this
							if (e.params._emitClasses && e.el) {
								var t = e.el.className.split(" ").filter(function (t) {
									return (
										0 === t.indexOf("swiper-container") ||
										0 === t.indexOf(e.params.containerModifierClass)
									)
								})
								e.emit("_containerClasses", t.join(" "))
							}
						}),
						(r.getSlideClasses = function (e) {
							var t = this
							return e.className
								.split(" ")
								.filter(function (e) {
									return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass)
								})
								.join(" ")
						}),
						(r.emitSlidesClasses = function () {
							var e = this
							if (e.params._emitClasses && e.el) {
								var t = []
								;(e.slides.each(function (i) {
									var n = e.getSlideClasses(i)
									;(t.push({ slideEl: i, classNames: n }), e.emit("_slideClass", i, n))
								}),
									e.emit("_slideClasses", t))
							}
						}),
						(r.slidesPerViewDynamic = function () {
							var e = this,
								t = e.params,
								i = e.slides,
								n = e.slidesGrid,
								s = e.size,
								r = e.activeIndex,
								a = 1
							if (t.centeredSlides) {
								for (var o, l = i[r].swiperSlideSize, d = r + 1; d < i.length; d += 1)
									i[d] && !o && ((a += 1), (l += i[d].swiperSlideSize) > s && (o = !0))
								for (var c = r - 1; c >= 0; c -= 1)
									i[c] && !o && ((a += 1), (l += i[c].swiperSlideSize) > s && (o = !0))
							} else for (var u = r + 1; u < i.length; u += 1) n[u] - n[r] < s && (a += 1)
							return a
						}),
						(r.update = function () {
							var e = this
							if (e && !e.destroyed) {
								var t = e.snapGrid,
									i = e.params
								;(i.breakpoints && e.setBreakpoint(),
									e.updateSize(),
									e.updateSlides(),
									e.updateProgress(),
									e.updateSlidesClasses(),
									e.params.freeMode
										? (n(), e.params.autoHeight && e.updateAutoHeight())
										: (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) &&
											e.isEnd &&
											!e.params.centeredSlides
												? e.slideTo(e.slides.length - 1, 0, !1, !0)
												: e.slideTo(e.activeIndex, 0, !1, !0)) || n(),
									i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
									e.emit("update"))
							}
							function n() {
								var t = e.rtlTranslate ? -1 * e.translate : e.translate,
									i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate())
								;(e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses())
							}
						}),
						(r.changeDirection = function (e, t) {
							void 0 === t && (t = !0)
							var i = this,
								n = i.params.direction
							return (
								e || (e = "horizontal" === n ? "vertical" : "horizontal"),
								e === n ||
									("horizontal" !== e && "vertical" !== e) ||
									(i.$el
										.removeClass("" + i.params.containerModifierClass + n)
										.addClass("" + i.params.containerModifierClass + e),
									i.emitContainerClasses(),
									(i.params.direction = e),
									i.slides.each(function (t) {
										"vertical" === e ? (t.style.width = "") : (t.style.height = "")
									}),
									i.emit("changeDirection"),
									t && i.update()),
								i
							)
						}),
						(r.mount = function (e) {
							var t = this
							if (t.mounted) return !0
							var i = y(e || t.params.el)
							if (!(e = i[0])) return !1
							e.swiper = t
							var n = function () {
									return "." + (t.params.wrapperClass || "").trim().split(" ").join(".")
								},
								r = (function () {
									if (e && e.shadowRoot && e.shadowRoot.querySelector) {
										var t = y(e.shadowRoot.querySelector(n()))
										return (
											(t.children = function (e) {
												return i.children(e)
											}),
											t
										)
									}
									return i.children(n())
								})()
							if (0 === r.length && t.params.createElements) {
								var a = s().createElement("div")
								;((r = y(a)),
									(a.className = t.params.wrapperClass),
									i.append(a),
									i.children("." + t.params.slideClass).each(function (e) {
										r.append(e)
									}))
							}
							return (
								S(t, {
									$el: i,
									el: e,
									$wrapperEl: r,
									wrapperEl: r[0],
									mounted: !0,
									rtl: "rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction"),
									rtlTranslate:
										"horizontal" === t.params.direction &&
										("rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction")),
									wrongRTL: "-webkit-box" === r.css("display"),
								}),
								!0
							)
						}),
						(r.init = function (e) {
							var t = this
							return (
								t.initialized ||
									!1 === t.mount(e) ||
									(t.emit("beforeInit"),
									t.params.breakpoints && t.setBreakpoint(),
									t.addClasses(),
									t.params.loop && t.loopCreate(),
									t.updateSize(),
									t.updateSlides(),
									t.params.watchOverflow && t.checkOverflow(),
									t.params.grabCursor && t.enabled && t.setGrabCursor(),
									t.params.preloadImages && t.preloadImages(),
									t.params.loop
										? t.slideTo(
												t.params.initialSlide + t.loopedSlides,
												0,
												t.params.runCallbacksOnInit,
												!1,
												!0,
											)
										: t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
									t.attachEvents(),
									(t.initialized = !0),
									t.emit("init"),
									t.emit("afterInit")),
								t
							)
						}),
						(r.destroy = function (e, t) {
							;(void 0 === e && (e = !0), void 0 === t && (t = !0))
							var i,
								n = this,
								s = n.params,
								r = n.$el,
								a = n.$wrapperEl,
								o = n.slides
							return (
								void 0 === n.params ||
									n.destroyed ||
									(n.emit("beforeDestroy"),
									(n.initialized = !1),
									n.detachEvents(),
									s.loop && n.loopDestroy(),
									t &&
										(n.removeClasses(),
										r.removeAttr("style"),
										a.removeAttr("style"),
										o &&
											o.length &&
											o
												.removeClass(
													[
														s.slideVisibleClass,
														s.slideActiveClass,
														s.slideNextClass,
														s.slidePrevClass,
													].join(" "),
												)
												.removeAttr("style")
												.removeAttr("data-swiper-slide-index")),
									n.emit("destroy"),
									Object.keys(n.eventsListeners).forEach(function (e) {
										n.off(e)
									}),
									!1 !== e &&
										((n.$el[0].swiper = null),
										(i = n),
										Object.keys(i).forEach(function (e) {
											try {
												i[e] = null
											} catch (e) {}
											try {
												delete i[e]
											} catch (e) {}
										})),
									(n.destroyed = !0)),
								null
							)
						}),
						(e.extendDefaults = function (e) {
							S(oe, e)
						}),
						(e.installModule = function (t) {
							e.prototype.modules || (e.prototype.modules = {})
							var i = t.name || Object.keys(e.prototype.modules).length + "_" + w()
							e.prototype.modules[i] = t
						}),
						(e.use = function (t) {
							return Array.isArray(t)
								? (t.forEach(function (t) {
										return e.installModule(t)
									}),
									e)
								: (e.installModule(t), e)
						}),
						(t = e),
						(n = [
							{
								key: "extendedDefaults",
								get: function () {
									return oe
								},
							},
							{
								key: "defaults",
								get: function () {
									return se
								},
							},
						]),
						(i = null) && re(t.prototype, i),
						n && re(t, n),
						e
					)
				})()
			;(Object.keys(ae).forEach(function (e) {
				Object.keys(ae[e]).forEach(function (t) {
					le.prototype[t] = ae[e][t]
				})
			}),
				le.use([I, N]))
			const de = le
			function ce() {
				return (
					(ce =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var i = arguments[t]
								for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
							}
							return e
						}),
					ce.apply(this, arguments)
				)
			}
			var ue = {
				toggleEl: function (e, t) {
					;(e[t ? "addClass" : "removeClass"](this.params.navigation.disabledClass),
						e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = t))
				},
				update: function () {
					var e = this,
						t = e.params.navigation,
						i = e.navigation.toggleEl
					if (!e.params.loop) {
						var n = e.navigation,
							s = n.$nextEl,
							r = n.$prevEl
						;(r &&
							r.length > 0 &&
							(e.isBeginning ? i(r, !0) : i(r, !1),
							e.params.watchOverflow &&
								e.enabled &&
								r[e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
							s &&
								s.length > 0 &&
								(e.isEnd ? i(s, !0) : i(s, !1),
								e.params.watchOverflow &&
									e.enabled &&
									s[e.isLocked ? "addClass" : "removeClass"](t.lockClass)))
					}
				},
				onPrevClick: function (e) {
					var t = this
					;(e.preventDefault(), (t.isBeginning && !t.params.loop) || t.slidePrev())
				},
				onNextClick: function (e) {
					var t = this
					;(e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext())
				},
				init: function () {
					var e,
						t,
						i = this,
						n = i.params.navigation
					;((i.params.navigation = M(i.$el, i.params.navigation, i.params.createElements, {
						nextEl: "swiper-button-next",
						prevEl: "swiper-button-prev",
					})),
					n.nextEl || n.prevEl) &&
						(n.nextEl &&
							((e = y(n.nextEl)),
							i.params.uniqueNavElements &&
								"string" == typeof n.nextEl &&
								e.length > 1 &&
								1 === i.$el.find(n.nextEl).length &&
								(e = i.$el.find(n.nextEl))),
						n.prevEl &&
							((t = y(n.prevEl)),
							i.params.uniqueNavElements &&
								"string" == typeof n.prevEl &&
								t.length > 1 &&
								1 === i.$el.find(n.prevEl).length &&
								(t = i.$el.find(n.prevEl))),
						e && e.length > 0 && e.on("click", i.navigation.onNextClick),
						t && t.length > 0 && t.on("click", i.navigation.onPrevClick),
						S(i.navigation, { $nextEl: e, nextEl: e && e[0], $prevEl: t, prevEl: t && t[0] }),
						i.enabled || (e && e.addClass(n.lockClass), t && t.addClass(n.lockClass)))
				},
				destroy: function () {
					var e = this,
						t = e.navigation,
						i = t.$nextEl,
						n = t.$prevEl
					;(i &&
						i.length &&
						(i.off("click", e.navigation.onNextClick),
						i.removeClass(e.params.navigation.disabledClass)),
						n &&
							n.length &&
							(n.off("click", e.navigation.onPrevClick),
							n.removeClass(e.params.navigation.disabledClass)))
				},
			}
			const pe = {
				name: "navigation",
				params: {
					navigation: {
						nextEl: null,
						prevEl: null,
						hideOnClick: !1,
						disabledClass: "swiper-button-disabled",
						hiddenClass: "swiper-button-hidden",
						lockClass: "swiper-button-lock",
					},
				},
				create: function () {
					E(this, { navigation: ce({}, ue) })
				},
				on: {
					init: function (e) {
						;(e.navigation.init(), e.navigation.update())
					},
					toEdge: function (e) {
						e.navigation.update()
					},
					fromEdge: function (e) {
						e.navigation.update()
					},
					destroy: function (e) {
						e.navigation.destroy()
					},
					"enable disable": function (e) {
						var t = e.navigation,
							i = t.$nextEl,
							n = t.$prevEl
						;(i && i[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass),
							n && n[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass))
					},
					click: function (e, t) {
						var i = e.navigation,
							n = i.$nextEl,
							s = i.$prevEl,
							r = t.target
						if (e.params.navigation.hideOnClick && !y(r).is(s) && !y(r).is(n)) {
							if (
								e.pagination &&
								e.params.pagination &&
								e.params.pagination.clickable &&
								(e.pagination.el === r || e.pagination.el.contains(r))
							)
								return
							var a
							;(n
								? (a = n.hasClass(e.params.navigation.hiddenClass))
								: s && (a = s.hasClass(e.params.navigation.hiddenClass)),
								!0 === a ? e.emit("navigationShow") : e.emit("navigationHide"),
								n && n.toggleClass(e.params.navigation.hiddenClass),
								s && s.toggleClass(e.params.navigation.hiddenClass))
						}
					},
				},
			}
			function he() {
				return (
					(he =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var i = arguments[t]
								for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
							}
							return e
						}),
					he.apply(this, arguments)
				)
			}
			var fe = {
				update: function () {
					var e = this,
						t = e.rtl,
						i = e.params.pagination
					if (i.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
						var n,
							s = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
							r = e.pagination.$el,
							a = e.params.loop
								? Math.ceil((s - 2 * e.loopedSlides) / e.params.slidesPerGroup)
								: e.snapGrid.length
						if (
							(e.params.loop
								? ((n = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) >
										s - 1 - 2 * e.loopedSlides && (n -= s - 2 * e.loopedSlides),
									n > a - 1 && (n -= a),
									n < 0 && "bullets" !== e.params.paginationType && (n = a + n))
								: (n = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
							"bullets" === i.type && e.pagination.bullets && e.pagination.bullets.length > 0)
						) {
							var o,
								l,
								d,
								c = e.pagination.bullets
							if (
								(i.dynamicBullets &&
									((e.pagination.bulletSize = c
										.eq(0)
										[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
									r.css(
										e.isHorizontal() ? "width" : "height",
										e.pagination.bulletSize * (i.dynamicMainBullets + 4) + "px",
									),
									i.dynamicMainBullets > 1 &&
										void 0 !== e.previousIndex &&
										((e.pagination.dynamicBulletIndex += n - e.previousIndex),
										e.pagination.dynamicBulletIndex > i.dynamicMainBullets - 1
											? (e.pagination.dynamicBulletIndex = i.dynamicMainBullets - 1)
											: e.pagination.dynamicBulletIndex < 0 &&
												(e.pagination.dynamicBulletIndex = 0)),
									(o = n - e.pagination.dynamicBulletIndex),
									(d = ((l = o + (Math.min(c.length, i.dynamicMainBullets) - 1)) + o) / 2)),
								c.removeClass(
									i.bulletActiveClass +
										" " +
										i.bulletActiveClass +
										"-next " +
										i.bulletActiveClass +
										"-next-next " +
										i.bulletActiveClass +
										"-prev " +
										i.bulletActiveClass +
										"-prev-prev " +
										i.bulletActiveClass +
										"-main",
								),
								r.length > 1)
							)
								c.each(function (e) {
									var t = y(e),
										s = t.index()
									;(s === n && t.addClass(i.bulletActiveClass),
										i.dynamicBullets &&
											(s >= o && s <= l && t.addClass(i.bulletActiveClass + "-main"),
											s === o &&
												t
													.prev()
													.addClass(i.bulletActiveClass + "-prev")
													.prev()
													.addClass(i.bulletActiveClass + "-prev-prev"),
											s === l &&
												t
													.next()
													.addClass(i.bulletActiveClass + "-next")
													.next()
													.addClass(i.bulletActiveClass + "-next-next")))
								})
							else {
								var u = c.eq(n),
									p = u.index()
								if ((u.addClass(i.bulletActiveClass), i.dynamicBullets)) {
									for (var h = c.eq(o), f = c.eq(l), v = o; v <= l; v += 1)
										c.eq(v).addClass(i.bulletActiveClass + "-main")
									if (e.params.loop)
										if (p >= c.length - i.dynamicMainBullets) {
											for (var m = i.dynamicMainBullets; m >= 0; m -= 1)
												c.eq(c.length - m).addClass(i.bulletActiveClass + "-main")
											c.eq(c.length - i.dynamicMainBullets - 1).addClass(
												i.bulletActiveClass + "-prev",
											)
										} else
											(h
												.prev()
												.addClass(i.bulletActiveClass + "-prev")
												.prev()
												.addClass(i.bulletActiveClass + "-prev-prev"),
												f
													.next()
													.addClass(i.bulletActiveClass + "-next")
													.next()
													.addClass(i.bulletActiveClass + "-next-next"))
									else
										(h
											.prev()
											.addClass(i.bulletActiveClass + "-prev")
											.prev()
											.addClass(i.bulletActiveClass + "-prev-prev"),
											f
												.next()
												.addClass(i.bulletActiveClass + "-next")
												.next()
												.addClass(i.bulletActiveClass + "-next-next"))
								}
							}
							if (i.dynamicBullets) {
								var g = Math.min(c.length, i.dynamicMainBullets + 4),
									b =
										(e.pagination.bulletSize * g - e.pagination.bulletSize) / 2 -
										d * e.pagination.bulletSize,
									w = t ? "right" : "left"
								c.css(e.isHorizontal() ? w : "top", b + "px")
							}
						}
						if (
							("fraction" === i.type &&
								(r.find(x(i.currentClass)).text(i.formatFractionCurrent(n + 1)),
								r.find(x(i.totalClass)).text(i.formatFractionTotal(a))),
							"progressbar" === i.type)
						) {
							var C
							C = i.progressbarOpposite
								? e.isHorizontal()
									? "vertical"
									: "horizontal"
								: e.isHorizontal()
									? "horizontal"
									: "vertical"
							var T = (n + 1) / a,
								S = 1,
								E = 1
							;("horizontal" === C ? (S = T) : (E = T),
								r
									.find(x(i.progressbarFillClass))
									.transform("translate3d(0,0,0) scaleX(" + S + ") scaleY(" + E + ")")
									.transition(e.params.speed))
						}
						;("custom" === i.type && i.renderCustom
							? (r.html(i.renderCustom(e, n + 1, a)), e.emit("paginationRender", r[0]))
							: e.emit("paginationUpdate", r[0]),
							e.params.watchOverflow &&
								e.enabled &&
								r[e.isLocked ? "addClass" : "removeClass"](i.lockClass))
					}
				},
				render: function () {
					var e = this,
						t = e.params.pagination
					if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
						var i =
								e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
							n = e.pagination.$el,
							s = ""
						if ("bullets" === t.type) {
							var r = e.params.loop
								? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup)
								: e.snapGrid.length
							e.params.freeMode && !e.params.loop && r > i && (r = i)
							for (var a = 0; a < r; a += 1)
								t.renderBullet
									? (s += t.renderBullet.call(e, a, t.bulletClass))
									: (s +=
											"<" +
											t.bulletElement +
											' class="' +
											t.bulletClass +
											'"></' +
											t.bulletElement +
											">")
							;(n.html(s), (e.pagination.bullets = n.find(x(t.bulletClass))))
						}
						;("fraction" === t.type &&
							((s = t.renderFraction
								? t.renderFraction.call(e, t.currentClass, t.totalClass)
								: '<span class="' +
									t.currentClass +
									'"></span> / <span class="' +
									t.totalClass +
									'"></span>'),
							n.html(s)),
							"progressbar" === t.type &&
								((s = t.renderProgressbar
									? t.renderProgressbar.call(e, t.progressbarFillClass)
									: '<span class="' + t.progressbarFillClass + '"></span>'),
								n.html(s)),
							"custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]))
					}
				},
				init: function () {
					var e = this
					e.params.pagination = M(e.$el, e.params.pagination, e.params.createElements, {
						el: "swiper-pagination",
					})
					var t = e.params.pagination
					if (t.el) {
						var i = y(t.el)
						0 !== i.length &&
							(e.params.uniqueNavElements &&
								"string" == typeof t.el &&
								i.length > 1 &&
								(i = e.$el.find(t.el)),
							"bullets" === t.type && t.clickable && i.addClass(t.clickableClass),
							i.addClass(t.modifierClass + t.type),
							"bullets" === t.type &&
								t.dynamicBullets &&
								(i.addClass("" + t.modifierClass + t.type + "-dynamic"),
								(e.pagination.dynamicBulletIndex = 0),
								t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
							"progressbar" === t.type &&
								t.progressbarOpposite &&
								i.addClass(t.progressbarOppositeClass),
							t.clickable &&
								i.on("click", x(t.bulletClass), function (t) {
									t.preventDefault()
									var i = y(this).index() * e.params.slidesPerGroup
									;(e.params.loop && (i += e.loopedSlides), e.slideTo(i))
								}),
							S(e.pagination, { $el: i, el: i[0] }),
							e.enabled || i.addClass(t.lockClass))
					}
				},
				destroy: function () {
					var e = this,
						t = e.params.pagination
					if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
						var i = e.pagination.$el
						;(i.removeClass(t.hiddenClass),
							i.removeClass(t.modifierClass + t.type),
							e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass),
							t.clickable && i.off("click", x(t.bulletClass)))
					}
				},
			}
			const ve = {
				name: "pagination",
				params: {
					pagination: {
						el: null,
						bulletElement: "span",
						clickable: !1,
						hideOnClick: !1,
						renderBullet: null,
						renderProgressbar: null,
						renderFraction: null,
						renderCustom: null,
						progressbarOpposite: !1,
						type: "bullets",
						dynamicBullets: !1,
						dynamicMainBullets: 1,
						formatFractionCurrent: function (e) {
							return e
						},
						formatFractionTotal: function (e) {
							return e
						},
						bulletClass: "swiper-pagination-bullet",
						bulletActiveClass: "swiper-pagination-bullet-active",
						modifierClass: "swiper-pagination-",
						currentClass: "swiper-pagination-current",
						totalClass: "swiper-pagination-total",
						hiddenClass: "swiper-pagination-hidden",
						progressbarFillClass: "swiper-pagination-progressbar-fill",
						progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
						clickableClass: "swiper-pagination-clickable",
						lockClass: "swiper-pagination-lock",
					},
				},
				create: function () {
					E(this, { pagination: he({ dynamicBulletIndex: 0 }, fe) })
				},
				on: {
					init: function (e) {
						;(e.pagination.init(), e.pagination.render(), e.pagination.update())
					},
					activeIndexChange: function (e) {
						;(e.params.loop || void 0 === e.snapIndex) && e.pagination.update()
					},
					snapIndexChange: function (e) {
						e.params.loop || e.pagination.update()
					},
					slidesLengthChange: function (e) {
						e.params.loop && (e.pagination.render(), e.pagination.update())
					},
					snapGridLengthChange: function (e) {
						e.params.loop || (e.pagination.render(), e.pagination.update())
					},
					destroy: function (e) {
						e.pagination.destroy()
					},
					"enable disable": function (e) {
						var t = e.pagination.$el
						t && t[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass)
					},
					click: function (e, t) {
						var i = t.target
						if (
							e.params.pagination.el &&
							e.params.pagination.hideOnClick &&
							e.pagination.$el.length > 0 &&
							!y(i).hasClass(e.params.pagination.bulletClass)
						) {
							if (
								e.navigation &&
								((e.navigation.nextEl && i === e.navigation.nextEl) ||
									(e.navigation.prevEl && i === e.navigation.prevEl))
							)
								return
							;(!0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass)
								? e.emit("paginationShow")
								: e.emit("paginationHide"),
								e.pagination.$el.toggleClass(e.params.pagination.hiddenClass))
						}
					},
				},
			}
			function me() {
				return (
					(me =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var i = arguments[t]
								for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
							}
							return e
						}),
					me.apply(this, arguments)
				)
			}
			var ge = {
				init: function () {
					var e = this,
						t = e.params.thumbs
					if (e.thumbs.initialized) return !1
					e.thumbs.initialized = !0
					var i = e.constructor
					return (
						t.swiper instanceof i
							? ((e.thumbs.swiper = t.swiper),
								S(e.thumbs.swiper.originalParams, {
									watchSlidesProgress: !0,
									slideToClickedSlide: !1,
								}),
								S(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }))
							: T(t.swiper) &&
								((e.thumbs.swiper = new i(
									S({}, t.swiper, {
										watchSlidesVisibility: !0,
										watchSlidesProgress: !0,
										slideToClickedSlide: !1,
									}),
								)),
								(e.thumbs.swiperCreated = !0)),
						e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
						e.thumbs.swiper.on("tap", e.thumbs.onThumbClick),
						!0
					)
				},
				onThumbClick: function () {
					var e = this,
						t = e.thumbs.swiper
					if (t) {
						var i = t.clickedIndex,
							n = t.clickedSlide
						if (!((n && y(n).hasClass(e.params.thumbs.slideThumbActiveClass)) || null == i)) {
							var s
							if (
								((s = t.params.loop
									? parseInt(y(t.clickedSlide).attr("data-swiper-slide-index"), 10)
									: i),
								e.params.loop)
							) {
								var r = e.activeIndex
								e.slides.eq(r).hasClass(e.params.slideDuplicateClass) &&
									(e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (r = e.activeIndex))
								var a = e.slides
										.eq(r)
										.prevAll('[data-swiper-slide-index="' + s + '"]')
										.eq(0)
										.index(),
									o = e.slides
										.eq(r)
										.nextAll('[data-swiper-slide-index="' + s + '"]')
										.eq(0)
										.index()
								s = void 0 === a ? o : void 0 === o ? a : o - r < r - a ? o : a
							}
							e.slideTo(s)
						}
					}
				},
				update: function (e) {
					var t = this,
						i = t.thumbs.swiper
					if (i) {
						var n =
								"auto" === i.params.slidesPerView
									? i.slidesPerViewDynamic()
									: i.params.slidesPerView,
							s = t.params.thumbs.autoScrollOffset,
							r = s && !i.params.loop
						if (t.realIndex !== i.realIndex || r) {
							var a,
								o,
								l = i.activeIndex
							if (i.params.loop) {
								i.slides.eq(l).hasClass(i.params.slideDuplicateClass) &&
									(i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft), (l = i.activeIndex))
								var d = i.slides
										.eq(l)
										.prevAll('[data-swiper-slide-index="' + t.realIndex + '"]')
										.eq(0)
										.index(),
									c = i.slides
										.eq(l)
										.nextAll('[data-swiper-slide-index="' + t.realIndex + '"]')
										.eq(0)
										.index()
								;((a =
									void 0 === d
										? c
										: void 0 === c
											? d
											: c - l == l - d
												? i.params.slidesPerGroup > 1
													? c
													: l
												: c - l < l - d
													? c
													: d),
									(o = t.activeIndex > t.previousIndex ? "next" : "prev"))
							} else o = (a = t.realIndex) > t.previousIndex ? "next" : "prev"
							;(r && (a += "next" === o ? s : -1 * s),
								i.visibleSlidesIndexes &&
									i.visibleSlidesIndexes.indexOf(a) < 0 &&
									(i.params.centeredSlides
										? (a = a > l ? a - Math.floor(n / 2) + 1 : a + Math.floor(n / 2) - 1)
										: a > l && i.params.slidesPerGroup,
									i.slideTo(a, e ? 0 : void 0)))
						}
						var u = 1,
							p = t.params.thumbs.slideThumbActiveClass
						if (
							(t.params.slidesPerView > 1 &&
								!t.params.centeredSlides &&
								(u = t.params.slidesPerView),
							t.params.thumbs.multipleActiveThumbs || (u = 1),
							(u = Math.floor(u)),
							i.slides.removeClass(p),
							i.params.loop || (i.params.virtual && i.params.virtual.enabled))
						)
							for (var h = 0; h < u; h += 1)
								i.$wrapperEl
									.children('[data-swiper-slide-index="' + (t.realIndex + h) + '"]')
									.addClass(p)
						else for (var f = 0; f < u; f += 1) i.slides.eq(t.realIndex + f).addClass(p)
					}
				},
			}
			const ye = {
				name: "thumbs",
				params: {
					thumbs: {
						swiper: null,
						multipleActiveThumbs: !0,
						autoScrollOffset: 0,
						slideThumbActiveClass: "swiper-slide-thumb-active",
						thumbsContainerClass: "swiper-container-thumbs",
					},
				},
				create: function () {
					E(this, { thumbs: me({ swiper: null, initialized: !1 }, ge) })
				},
				on: {
					beforeInit: function (e) {
						var t = e.params.thumbs
						t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0))
					},
					slideChange: function (e) {
						e.thumbs.swiper && e.thumbs.update()
					},
					update: function (e) {
						e.thumbs.swiper && e.thumbs.update()
					},
					resize: function (e) {
						e.thumbs.swiper && e.thumbs.update()
					},
					observerUpdate: function (e) {
						e.thumbs.swiper && e.thumbs.update()
					},
					setTransition: function (e, t) {
						var i = e.thumbs.swiper
						i && i.setTransition(t)
					},
					beforeDestroy: function (e) {
						var t = e.thumbs.swiper
						t && e.thumbs.swiperCreated && t && t.destroy()
					},
				},
			}
			function be() {
				return (
					(be =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var i = arguments[t]
								for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
							}
							return e
						}),
					be.apply(this, arguments)
				)
			}
			var we = {
				run: function () {
					var e = this,
						t = e.slides.eq(e.activeIndex),
						i = e.params.autoplay.delay
					;(t.attr("data-swiper-autoplay") &&
						(i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
						clearTimeout(e.autoplay.timeout),
						(e.autoplay.timeout = b(function () {
							var t
							;(e.params.autoplay.reverseDirection
								? e.params.loop
									? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
									: e.isBeginning
										? e.params.autoplay.stopOnLastSlide
											? e.autoplay.stop()
											: ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)),
												e.emit("autoplay"))
										: ((t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
								: e.params.loop
									? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay"))
									: e.isEnd
										? e.params.autoplay.stopOnLastSlide
											? e.autoplay.stop()
											: ((t = e.slideTo(0, e.params.speed, !0, !0)), e.emit("autoplay"))
										: ((t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay")),
								((e.params.cssMode && e.autoplay.running) || !1 === t) && e.autoplay.run())
						}, i)))
				},
				start: function () {
					var e = this
					return (
						void 0 === e.autoplay.timeout &&
						!e.autoplay.running &&
						((e.autoplay.running = !0), e.emit("autoplayStart"), e.autoplay.run(), !0)
					)
				},
				stop: function () {
					var e = this
					return (
						!!e.autoplay.running &&
						void 0 !== e.autoplay.timeout &&
						(e.autoplay.timeout &&
							(clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)),
						(e.autoplay.running = !1),
						e.emit("autoplayStop"),
						!0)
					)
				},
				pause: function (e) {
					var t = this
					t.autoplay.running &&
						(t.autoplay.paused ||
							(t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
							(t.autoplay.paused = !0),
							0 !== e && t.params.autoplay.waitForTransition
								? ["transitionend", "webkitTransitionEnd"].forEach(function (e) {
										t.$wrapperEl[0].addEventListener(e, t.autoplay.onTransitionEnd)
									})
								: ((t.autoplay.paused = !1), t.autoplay.run())))
				},
				onVisibilityChange: function () {
					var e = this,
						t = s()
					;("hidden" === t.visibilityState && e.autoplay.running && e.autoplay.pause(),
						"visible" === t.visibilityState &&
							e.autoplay.paused &&
							(e.autoplay.run(), (e.autoplay.paused = !1)))
				},
				onTransitionEnd: function (e) {
					var t = this
					t &&
						!t.destroyed &&
						t.$wrapperEl &&
						e.target === t.$wrapperEl[0] &&
						(["transitionend", "webkitTransitionEnd"].forEach(function (e) {
							t.$wrapperEl[0].removeEventListener(e, t.autoplay.onTransitionEnd)
						}),
						(t.autoplay.paused = !1),
						t.autoplay.running ? t.autoplay.run() : t.autoplay.stop())
				},
				onMouseEnter: function () {
					var e = this
					;(e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause(),
						["transitionend", "webkitTransitionEnd"].forEach(function (t) {
							e.$wrapperEl[0].removeEventListener(t, e.autoplay.onTransitionEnd)
						}))
				},
				onMouseLeave: function () {
					var e = this
					e.params.autoplay.disableOnInteraction || ((e.autoplay.paused = !1), e.autoplay.run())
				},
				attachMouseEvents: function () {
					var e = this
					e.params.autoplay.pauseOnMouseEnter &&
						(e.$el.on("mouseenter", e.autoplay.onMouseEnter),
						e.$el.on("mouseleave", e.autoplay.onMouseLeave))
				},
				detachMouseEvents: function () {
					var e = this
					;(e.$el.off("mouseenter", e.autoplay.onMouseEnter),
						e.$el.off("mouseleave", e.autoplay.onMouseLeave))
				},
			}
			const Ce = {
				name: "autoplay",
				params: {
					autoplay: {
						enabled: !1,
						delay: 3e3,
						waitForTransition: !0,
						disableOnInteraction: !0,
						stopOnLastSlide: !1,
						reverseDirection: !1,
						pauseOnMouseEnter: !1,
					},
				},
				create: function () {
					E(this, { autoplay: be({}, we, { running: !1, paused: !1 }) })
				},
				on: {
					init: function (e) {
						e.params.autoplay.enabled &&
							(e.autoplay.start(),
							s().addEventListener("visibilitychange", e.autoplay.onVisibilityChange),
							e.autoplay.attachMouseEvents())
					},
					beforeTransitionStart: function (e, t, i) {
						e.autoplay.running &&
							(i || !e.params.autoplay.disableOnInteraction
								? e.autoplay.pause(t)
								: e.autoplay.stop())
					},
					sliderFirstMove: function (e) {
						e.autoplay.running &&
							(e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause())
					},
					touchEnd: function (e) {
						e.params.cssMode &&
							e.autoplay.paused &&
							!e.params.autoplay.disableOnInteraction &&
							e.autoplay.run()
					},
					destroy: function (e) {
						;(e.autoplay.detachMouseEvents(),
							e.autoplay.running && e.autoplay.stop(),
							s().removeEventListener("visibilitychange", e.autoplay.onVisibilityChange))
					},
				},
			}
			function Te() {
				return (
					(Te =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var i = arguments[t]
								for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
							}
							return e
						}),
					Te.apply(this, arguments)
				)
			}
			var Se = {
				setTranslate: function () {
					for (var e = this, t = e.slides, i = 0; i < t.length; i += 1) {
						var n = e.slides.eq(i),
							s = -n[0].swiperSlideOffset
						e.params.virtualTranslate || (s -= e.translate)
						var r = 0
						e.isHorizontal() || ((r = s), (s = 0))
						var a = e.params.fadeEffect.crossFade
							? Math.max(1 - Math.abs(n[0].progress), 0)
							: 1 + Math.min(Math.max(n[0].progress, -1), 0)
						n.css({ opacity: a }).transform("translate3d(" + s + "px, " + r + "px, 0px)")
					}
				},
				setTransition: function (e) {
					var t = this,
						i = t.slides,
						n = t.$wrapperEl
					if ((i.transition(e), t.params.virtualTranslate && 0 !== e)) {
						var s = !1
						i.transitionEnd(function () {
							if (!s && t && !t.destroyed) {
								;((s = !0), (t.animating = !1))
								for (var e = ["webkitTransitionEnd", "transitionend"], i = 0; i < e.length; i += 1)
									n.trigger(e[i])
							}
						})
					}
				},
			}
			const Ee = {
				name: "effect-fade",
				params: { fadeEffect: { crossFade: !1 } },
				create: function () {
					E(this, { fadeEffect: Te({}, Se) })
				},
				on: {
					beforeInit: function (e) {
						if ("fade" === e.params.effect) {
							e.classNames.push(e.params.containerModifierClass + "fade")
							var t = {
								slidesPerView: 1,
								slidesPerColumn: 1,
								slidesPerGroup: 1,
								watchSlidesProgress: !0,
								spaceBetween: 0,
								virtualTranslate: !0,
							}
							;(S(e.params, t), S(e.originalParams, t))
						}
					},
					setTranslate: function (e) {
						"fade" === e.params.effect && e.fadeEffect.setTranslate()
					},
					setTransition: function (e, t) {
						"fade" === e.params.effect && e.fadeEffect.setTransition(t)
					},
				},
			}
			;(i(924), de.use([pe, ve, ye, Ce, Ee]))
			const xe = de
			var Me = i(367),
				ke = i.n(Me)
			function Oe(e) {
				return (
					(Oe =
						"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
							? function (e) {
									return typeof e
								}
							: function (e) {
									return e &&
										"function" == typeof Symbol &&
										e.constructor === Symbol &&
										e !== Symbol.prototype
										? "symbol"
										: typeof e
								}),
					Oe(e)
				)
			}
			function Pe(e) {
				var t = (function (e, t) {
					if ("object" !== Oe(e) || null === e) return e
					var i = e[Symbol.toPrimitive]
					if (void 0 !== i) {
						var n = i.call(e, t || "default")
						if ("object" !== Oe(n)) return n
						throw new TypeError("@@toPrimitive must return a primitive value.")
					}
					return ("string" === t ? String : Number)(e)
				})(e, "string")
				return "symbol" === Oe(t) ? t : String(t)
			}
			function Le(e, t, i) {
				return (
					(t = Pe(t)) in e
						? Object.defineProperty(e, t, {
								value: i,
								enumerable: !0,
								configurable: !0,
								writable: !0,
							})
						: (e[t] = i),
					e
				)
			}
			var Ae = i(295).Z
			function ze() {
				return Ae(
					"div",
					{ className: "m-modal m-modal--wrapper m:flex m:items-center m:justify-center" },
					Ae(
						"div",
						{ className: "m-modal--content" },
						Ae(
							"button",
							{ className: "m-modal--close", "aria-label": "Close" },
							Ae(
								"svg",
								{
									fill: "none",
									stroke: "currentColor",
									viewBox: "0 0 24 24",
									xmlns: "http://www.w3.org/2000/svg",
								},
								Ae("path", {
									"stroke-linecap": "round",
									"stroke-linejoin": "round",
									"stroke-width": "2",
									d: "M6 18L18 6M6 6l12 12",
								}),
							),
						),
						Ae("div", { className: "m-modal--content-inner" }),
					),
				)
			}
			var Ie = i(295).Z
			const De = class {
				constructor() {
					var e, t
					;(Le(this, "init", () => {
						addEventDelegate({
							selector: ".m-modal--wrapper",
							handler: (e) => {
								var t
								;((null == e ? void 0 : e.target) === this.modal ||
									(null != e &&
										null !== (t = e.target) &&
										void 0 !== t &&
										t.closest(".m-modal--close"))) &&
									this.close(e)
							},
						})
					}),
						Le(this, "setSizes", (e = "") => {
							;(this.resetSize(),
								(this.sizes = e),
								e.split(" ").forEach((e) => {
									var t, i
									null === (t = this.modalContent) ||
										void 0 === t ||
										null === (i = t.classList) ||
										void 0 === i ||
										i.add(e)
								}))
						}),
						Le(this, "setWidth", (e) => {
							this.modalContent.style.width = e
						}),
						Le(this, "resetSize", () => {
							this.sizes &&
								(this.sizes.split(" ").forEach((e) => {
									var t, i
									null === (t = this.modalContent) ||
										void 0 === t ||
										null === (i = t.classList) ||
										void 0 === i ||
										i.remove(e)
								}),
								(this.sizes = ""))
						}),
						Le(this, "appendChild", (e) => {
							var t
							;(null == this ||
								null === (t = this.modalContentInner) ||
								void 0 === t ||
								t.appendChild(e),
								(this.children = e))
						}),
						Le(this, "removeChild", () => {
							var e
							null == this || null === (e = this.children) || void 0 === e || e.remove()
						}),
						Le(this, "open", () => {
							;(document.documentElement.classList.add("prevent-scroll"),
								document.body.appendChild(this.modal),
								setTimeout(() => {
									;(this.modal.style.setProperty("--m-opacity", "1"),
										this.modal.classList.add("m-open-modal"))
								}, this.transitionDuration),
								window.addEventListener("keydown", this.handleKeyDown))
						}),
						Le(this, "close", (e) => {
							;(e && e.preventDefault(),
								this.modal.classList.remove("m-open-modal"),
								this.modal.style.setProperty("--m-opacity", "0"),
								window.removeEventListener("keydown", this.handleKeyDown),
								setTimeout(() => {
									;(this.modal.remove(),
										this.removeChild(),
										this.resetSize(),
										this.modalContent.style.removeProperty("width"),
										document.documentElement.classList.remove("prevent-scroll"))
								}, this.transitionDuration))
						}),
						Le(this, "handleKeyDown", (e) => {
							27 === e.keyCode && this.close()
						}),
						(this.modal = Ie(ze, null)),
						(this.modalContent =
							null === (e = this.modal) || void 0 === e
								? void 0
								: e.querySelector(".m-modal--content")),
						(this.modalContentInner =
							null === (t = this.modal) || void 0 === t
								? void 0
								: t.querySelector(".m-modal--content-inner")),
						(this.transitionDuration = 200),
						this.init())
				}
			}
			var Be = i(643),
				Ne = i.n(Be),
				je = i(295).Z
			function $e({ type: e, message: t, onclick: i, sticky: n }) {
				let s
				return (
					(s = je(
						"svg",
						{
							className: "m-svg-icon--large",
							fill: "none",
							stroke: "currentColor",
							viewBox: "0 0 24 24",
							xmlns: "http://www.w3.org/2000/svg",
						},
						je(
							"path",
							"warning" === e
								? {
										"stroke-linecap": "round",
										"stroke-linejoin": "round",
										"stroke-width": "2",
										d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
									}
								: "success" === e
									? {
											"stroke-linecap": "round",
											"stroke-linejoin": "round",
											"stroke-width": "2",
											d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
										}
									: {
											"stroke-linecap": "round",
											"stroke-linejoin": "round",
											"stroke-width": "2",
											d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
										},
						),
					)),
					je(
						"div",
						{ className: `notification ${e} ${n ? "notification--sticky" : null}`, onclick: i },
						s,
						je("div", { className: "notification__text" }, t),
					)
				)
			}
			var _e = i(295).Z
			function He(e, t) {
				var i
				return (
					"string" == typeof e
						? t
							? ((null !== (i = t[e]) && void 0 !== i) || (t[e] = document.querySelectorAll(e)),
								(e = t[e]))
							: (e = document.querySelectorAll(e))
						: e instanceof Element && (e = [e]),
					Array.from(e || [])
				)
			}
			const Ge = (e) => "function" == typeof e,
				Fe = { any: 0, all: 1 }
			const We = { duration: 0.3, delay: 0, endDelay: 0, repeat: 0, easing: "ease" },
				Ve = { ms: (e) => 1e3 * e, s: (e) => e / 1e3 },
				qe = () => {},
				Re = (e) => e
			function Xe(e, t = !0) {
				if (e && "finished" !== e.playState)
					try {
						e.stop ? e.stop() : (t && e.commitStyles(), e.cancel())
					} catch (e) {}
			}
			const Ye = (e) => e(),
				Ue = (e, t, i = We.duration) =>
					new Proxy({ animations: e.map(Ye).filter(Boolean), duration: i, options: t }, Ke),
				Ke = {
					get: (e, t) => {
						const i = e.animations[0]
						switch (t) {
							case "duration":
								return e.duration
							case "currentTime":
								return Ve.s((null == i ? void 0 : i[t]) || 0)
							case "playbackRate":
							case "playState":
								return null == i ? void 0 : i[t]
							case "finished":
								return (
									e.finished || (e.finished = Promise.all(e.animations.map(Ze)).catch(qe)),
									e.finished
								)
							case "stop":
								return () => {
									e.animations.forEach((e) => Xe(e))
								}
							case "forEachNative":
								return (t) => {
									e.animations.forEach((i) => t(i, e))
								}
							default:
								return void 0 === (null == i ? void 0 : i[t])
									? void 0
									: () => e.animations.forEach((e) => e[t]())
						}
					},
					set: (e, t, i) => {
						switch (t) {
							case "currentTime":
								i = Ve.ms(i)
							case "playbackRate":
								for (let n = 0; n < e.animations.length; n++) e.animations[n][t] = i
								return !0
						}
						return !1
					},
				},
				Ze = (e) => e.finished,
				Je = (e) => "object" == typeof e && Boolean(e.createAnimation),
				Qe = (e) => "number" == typeof e,
				et = (e) => Array.isArray(e) && !Qe(e[0]),
				tt = (e, t, i) => -i * e + i * t + e,
				it = (e, t, i) => (t - e == 0 ? 1 : (i - e) / (t - e))
			function nt(e, t) {
				const i = e[e.length - 1]
				for (let n = 1; n <= t; n++) {
					const s = it(0, t, n)
					e.push(tt(i, 1, s))
				}
			}
			function st(e) {
				const t = [0]
				return (nt(t, e - 1), t)
			}
			const rt = (e, t, i) => {
				const n = t - e
				return ((((i - e) % n) + n) % n) + e
			}
			const at = (e, t, i) => Math.min(Math.max(i, e), t)
			function ot(e, t = st(e.length), i = Re) {
				const n = e.length,
					s = n - t.length
				return (
					s > 0 && nt(t, s),
					(s) => {
						let r = 0
						for (; r < n - 2 && !(s < t[r + 1]); r++);
						let a = at(0, 1, it(t[r], t[r + 1], s))
						const o = (function (e, t) {
							return et(e) ? e[rt(0, e.length, t)] : e
						})(i, r)
						return ((a = o(a)), tt(e[r], e[r + 1], a))
					}
				)
			}
			const lt = (e, t, i) => (((1 - 3 * i + 3 * t) * e + (3 * i - 6 * t)) * e + 3 * t) * e,
				dt = 1e-7,
				ct = 12
			function ut(e, t, i, n) {
				if (e === t && i === n) return Re
				const s = (t) =>
					(function (e, t, i, n, s) {
						let r,
							a,
							o = 0
						do {
							;((a = t + (i - t) / 2), (r = lt(a, n, s) - e), r > 0 ? (i = a) : (t = a))
						} while (Math.abs(r) > dt && ++o < ct)
						return a
					})(t, 0, 1, e, i)
				return (e) => (0 === e || 1 === e ? e : lt(s(e), t, n))
			}
			const pt = (e) => Array.isArray(e) && Qe(e[0]),
				ht = {
					ease: ut(0.25, 0.1, 0.25, 1),
					"ease-in": ut(0.42, 0, 1, 1),
					"ease-in-out": ut(0.42, 0, 0.58, 1),
					"ease-out": ut(0, 0, 0.58, 1),
				},
				ft = /\((.*?)\)/
			function vt(e) {
				if (Ge(e)) return e
				if (pt(e)) return ut(...e)
				if (ht[e]) return ht[e]
				if (e.startsWith("steps")) {
					const t = ft.exec(e)
					if (t) {
						const e = t[1].split(",")
						return (
							(e, t = "end") =>
							(i) => {
								const n = (i = "end" === t ? Math.min(i, 0.999) : Math.max(i, 0.001)) * e,
									s = "end" === t ? Math.floor(n) : Math.ceil(n)
								return at(0, 1, s / e)
							}
						)(parseFloat(e[0]), e[1].trim())
					}
				}
				return Re
			}
			class mt {
				constructor(
					e,
					t = [0, 1],
					{
						easing: i,
						duration: n = We.duration,
						delay: s = We.delay,
						endDelay: r = We.endDelay,
						repeat: a = We.repeat,
						offset: o,
						direction: l = "normal",
						autoplay: d = !0,
					} = {},
				) {
					if (
						((this.startTime = null),
						(this.rate = 1),
						(this.t = 0),
						(this.cancelTimestamp = null),
						(this.easing = Re),
						(this.duration = 0),
						(this.totalDuration = 0),
						(this.repeat = 0),
						(this.playState = "idle"),
						(this.finished = new Promise((e, t) => {
							;((this.resolve = e), (this.reject = t))
						})),
						(i = i || We.easing),
						Je(i))
					) {
						const e = i.createAnimation(t)
						;((i = e.easing), (t = e.keyframes || t), (n = e.duration || n))
					}
					;((this.repeat = a), (this.easing = et(i) ? Re : vt(i)), this.updateDuration(n))
					const c = ot(t, o, et(i) ? i.map(vt) : Re)
					;((this.tick = (t) => {
						var i
						let n = 0
						;((n = void 0 !== this.pauseTime ? this.pauseTime : (t - this.startTime) * this.rate),
							(this.t = n),
							(n /= 1e3),
							(n = Math.max(n - s, 0)),
							"finished" === this.playState &&
								void 0 === this.pauseTime &&
								(n = this.totalDuration))
						const a = n / this.duration
						let o = Math.floor(a),
							d = a % 1
						;(!d && a >= 1 && (d = 1), 1 === d && o--)
						const u = o % 2
						;("reverse" === l || ("alternate" === l && u) || ("alternate-reverse" === l && !u)) &&
							(d = 1 - d)
						const p = n >= this.totalDuration ? 1 : Math.min(d, 1),
							h = c(this.easing(p))
						e(h)
						void 0 === this.pauseTime &&
						("finished" === this.playState || n >= this.totalDuration + r)
							? ((this.playState = "finished"),
								null === (i = this.resolve) || void 0 === i || i.call(this, h))
							: "idle" !== this.playState &&
								(this.frameRequestId = requestAnimationFrame(this.tick))
					}),
						d && this.play())
				}
				play() {
					const e = performance.now()
					;((this.playState = "running"),
						void 0 !== this.pauseTime
							? (this.startTime = e - this.pauseTime)
							: this.startTime || (this.startTime = e),
						(this.cancelTimestamp = this.startTime),
						(this.pauseTime = void 0),
						(this.frameRequestId = requestAnimationFrame(this.tick)))
				}
				pause() {
					;((this.playState = "paused"), (this.pauseTime = this.t))
				}
				finish() {
					;((this.playState = "finished"), this.tick(0))
				}
				stop() {
					var e
					;((this.playState = "idle"),
						void 0 !== this.frameRequestId && cancelAnimationFrame(this.frameRequestId),
						null === (e = this.reject) || void 0 === e || e.call(this, !1))
				}
				cancel() {
					;(this.stop(), this.tick(this.cancelTimestamp))
				}
				reverse() {
					this.rate *= -1
				}
				commitStyles() {}
				updateDuration(e) {
					;((this.duration = e), (this.totalDuration = e * (this.repeat + 1)))
				}
				get currentTime() {
					return this.t
				}
				set currentTime(e) {
					void 0 !== this.pauseTime || 0 === this.rate
						? (this.pauseTime = e)
						: (this.startTime = performance.now() - e / this.rate)
				}
				get playbackRate() {
					return this.rate
				}
				set playbackRate(e) {
					this.rate = e
				}
			}
			class gt {
				setAnimation(e) {
					;((this.animation = e),
						null == e || e.finished.then(() => this.clearAnimation()).catch(() => {}))
				}
				clearAnimation() {
					this.animation = this.generator = void 0
				}
			}
			const yt = new WeakMap()
			function bt(e) {
				return (yt.has(e) || yt.set(e, { transforms: [], values: new Map() }), yt.get(e))
			}
			const wt = ["", "X", "Y", "Z"],
				Ct = { x: "translateX", y: "translateY", z: "translateZ" },
				Tt = { syntax: "<angle>", initialValue: "0deg", toDefaultUnit: (e) => e + "deg" },
				St = {
					translate: {
						syntax: "<length-percentage>",
						initialValue: "0px",
						toDefaultUnit: (e) => e + "px",
					},
					rotate: Tt,
					scale: { syntax: "<number>", initialValue: 1, toDefaultUnit: Re },
					skew: Tt,
				},
				Et = new Map(),
				xt = (e) => `--motion-${e}`,
				Mt = ["x", "y", "z"]
			;["translate", "scale", "rotate", "skew"].forEach((e) => {
				wt.forEach((t) => {
					;(Mt.push(e + t), Et.set(xt(e + t), St[e]))
				})
			})
			const kt = (e, t) => Mt.indexOf(e) - Mt.indexOf(t),
				Ot = new Set(Mt),
				Pt = (e) => Ot.has(e),
				Lt = (e, t) => {
					Ct[t] && (t = Ct[t])
					const { transforms: i } = bt(e)
					var n, s
					;((s = t), -1 === (n = i).indexOf(s) && n.push(s), (e.style.transform = At(i)))
				},
				At = (e) => e.sort(kt).reduce(zt, "").trim(),
				zt = (e, t) => `${e} ${t}(var(${xt(t)}))`,
				It = (e) => e.startsWith("--"),
				Dt = new Set()
			const Bt = (e, t) => document.createElement("div").animate(e, t),
				Nt = {
					cssRegisterProperty: () =>
						"undefined" != typeof CSS && Object.hasOwnProperty.call(CSS, "registerProperty"),
					waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
					partialKeyframes: () => {
						try {
							Bt({ opacity: [1] })
						} catch (e) {
							return !1
						}
						return !0
					},
					finished: () => Boolean(Bt({ opacity: [0, 1] }, { duration: 0.001 }).finished),
					linearEasing: () => {
						try {
							Bt({ opacity: 0 }, { easing: "linear(0, 1)" })
						} catch (e) {
							return !1
						}
						return !0
					},
				},
				jt = {},
				$t = {}
			for (const e in Nt) $t[e] = () => (void 0 === jt[e] && (jt[e] = Nt[e]()), jt[e])
			const _t = (e, t) =>
					Ge(e)
						? $t.linearEasing()
							? `linear(${((e, t) => {
									let i = ""
									const n = Math.round(t / 0.015)
									for (let t = 0; t < n; t++) i += e(it(0, n - 1, t)) + ", "
									return i.substring(0, i.length - 2)
								})(e, t)})`
							: We.easing
						: pt(e)
							? Ht(e)
							: e,
				Ht = ([e, t, i, n]) => `cubic-bezier(${e}, ${t}, ${i}, ${n})`
			const Gt = (e) => (Array.isArray(e) ? e : [e])
			function Ft(e) {
				return (Ct[e] && (e = Ct[e]), Pt(e) ? xt(e) : e)
			}
			const Wt = {
					get: (e, t) => {
						t = Ft(t)
						let i = It(t) ? e.style.getPropertyValue(t) : getComputedStyle(e)[t]
						if (!i && 0 !== i) {
							const e = Et.get(t)
							e && (i = e.initialValue)
						}
						return i
					},
					set: (e, t, i) => {
						;((t = Ft(t)), It(t) ? e.style.setProperty(t, i) : (e.style[t] = i))
					},
				},
				Vt = (e) => "string" == typeof e
			function qt(e, t, i, n = {}, s) {
				const r = window.__MOTION_DEV_TOOLS_RECORD,
					a = !1 !== n.record && r
				let o,
					{
						duration: l = We.duration,
						delay: d = We.delay,
						endDelay: c = We.endDelay,
						repeat: u = We.repeat,
						easing: p = We.easing,
						persist: h = !1,
						direction: f,
						offset: v,
						allowWebkitAcceleration: m = !1,
						autoplay: g = !0,
					} = n
				const y = bt(e),
					b = Pt(t)
				let w = $t.waapi()
				b && Lt(e, t)
				const C = Ft(t),
					T = (function (e, t) {
						return (e.has(t) || e.set(t, new gt()), e.get(t))
					})(y.values, C),
					S = Et.get(C)
				return (
					Xe(T.animation, !(Je(p) && T.generator) && !1 !== n.record),
					() => {
						const y = () => {
							var t, i
							return null !==
								(i =
									null !== (t = Wt.get(e, C)) && void 0 !== t
										? t
										: null == S
											? void 0
											: S.initialValue) && void 0 !== i
								? i
								: 0
						}
						let E = (function (e, t) {
							for (let i = 0; i < e.length; i++) null === e[i] && (e[i] = i ? e[i - 1] : t())
							return e
						})(Gt(i), y)
						const x = (function (e, t) {
							var i
							let n = (null == t ? void 0 : t.toDefaultUnit) || Re
							const s = e[e.length - 1]
							if (Vt(s)) {
								const e =
									(null === (i = s.match(/(-?[\d.]+)([a-z%]*)/)) || void 0 === i ? void 0 : i[2]) ||
									""
								e && (n = (t) => t + e)
							}
							return n
						})(E, S)
						if (Je(p)) {
							const e = p.createAnimation(E, "opacity" !== t, y, C, T)
							;((p = e.easing), (E = e.keyframes || E), (l = e.duration || l))
						}
						if (
							(It(C) &&
								($t.cssRegisterProperty()
									? (function (e) {
											if (!Dt.has(e)) {
												Dt.add(e)
												try {
													const { syntax: t, initialValue: i } = Et.has(e) ? Et.get(e) : {}
													CSS.registerProperty({
														name: e,
														inherits: !1,
														syntax: t,
														initialValue: i,
													})
												} catch (e) {}
											}
										})(C)
									: (w = !1)),
							b && !$t.linearEasing() && (Ge(p) || (et(p) && p.some(Ge))) && (w = !1),
							w)
						) {
							;(S && (E = E.map((e) => (Qe(e) ? S.toDefaultUnit(e) : e))),
								1 !== E.length || ($t.partialKeyframes() && !a) || E.unshift(y()))
							const t = {
								delay: Ve.ms(d),
								duration: Ve.ms(l),
								endDelay: Ve.ms(c),
								easing: et(p) ? void 0 : _t(p, l),
								direction: f,
								iterations: u + 1,
								fill: "both",
							}
							;((o = e.animate(
								{ [C]: E, offset: v, easing: et(p) ? p.map((e) => _t(e, l)) : void 0 },
								t,
							)),
								o.finished ||
									(o.finished = new Promise((e, t) => {
										;((o.onfinish = e), (o.oncancel = t))
									})))
							const i = E[E.length - 1]
							;(o.finished
								.then(() => {
									h || (Wt.set(e, C, i), o.cancel())
								})
								.catch(qe),
								m || (o.playbackRate = 1.000001))
						} else if (s && b)
							((E = E.map((e) => ("string" == typeof e ? parseFloat(e) : e))),
								1 === E.length && E.unshift(parseFloat(y())),
								(o = new s(
									(t) => {
										Wt.set(e, C, x ? x(t) : t)
									},
									E,
									Object.assign(Object.assign({}, n), { duration: l, easing: p }),
								)))
						else {
							const t = E[E.length - 1]
							Wt.set(e, C, S && Qe(t) ? S.toDefaultUnit(t) : t)
						}
						return (
							a &&
								r(
									e,
									t,
									E,
									{ duration: l, delay: d, easing: p, repeat: u, offset: v },
									"motion-one",
								),
							T.setAnimation(o),
							o && !g && o.pause(),
							o
						)
					}
				)
			}
			const Rt = (e, t) => (e[t] ? Object.assign(Object.assign({}, e), e[t]) : Object.assign({}, e))
			function Xt(e, t, i) {
				return Ge(e) ? e(t, i) : e
			}
			const Yt =
				((Ut = mt),
				function (e, t, i = {}) {
					const n = (e = He(e)).length
					;(Boolean(n), Boolean(t))
					const s = []
					for (let r = 0; r < n; r++) {
						const a = e[r]
						for (const e in t) {
							const o = Rt(i, e)
							o.delay = Xt(o.delay, r, n)
							const l = qt(a, e, t[e], o, Ut)
							s.push(l)
						}
					}
					return Ue(s, i, i.duration)
				})
			var Ut
			function Kt(e, t = {}) {
				return Ue(
					[
						() => {
							const i = new mt(e, [0, 1], t)
							return (i.finished.catch(() => {}), i)
						},
					],
					t,
					t.duration,
				)
			}
			function Zt(e, t) {
				var i = {}
				for (var n in e)
					Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n])
				if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
					var s = 0
					for (n = Object.getOwnPropertySymbols(e); s < n.length; s++)
						t.indexOf(n[s]) < 0 &&
							Object.prototype.propertyIsEnumerable.call(e, n[s]) &&
							(i[n[s]] = e[n[s]])
				}
				return i
			}
			Object.create
			Object.create
			"function" == typeof SuppressedError && SuppressedError
			const Jt = new WeakMap()
			let Qt
			function ei({ target: e, contentRect: t, borderBoxSize: i }) {
				var n
				null === (n = Jt.get(e)) ||
					void 0 === n ||
					n.forEach((n) => {
						n({
							target: e,
							contentSize: t,
							get size() {
								return (function (e, t) {
									if (t) {
										const { inlineSize: e, blockSize: i } = t[0]
										return { width: e, height: i }
									}
									return e instanceof SVGElement && "getBBox" in e
										? e.getBBox()
										: { width: e.offsetWidth, height: e.offsetHeight }
								})(e, i)
							},
						})
					})
			}
			function ti(e) {
				e.forEach(ei)
			}
			function ii(e, t) {
				Qt || ("undefined" != typeof ResizeObserver && (Qt = new ResizeObserver(ti)))
				const i = He(e)
				return (
					i.forEach((e) => {
						let i = Jt.get(e)
						;(i || ((i = new Set()), Jt.set(e, i)), i.add(t), null == Qt || Qt.observe(e))
					}),
					() => {
						i.forEach((e) => {
							const i = Jt.get(e)
							;(null == i || i.delete(t),
								(null == i ? void 0 : i.size) || null == Qt || Qt.unobserve(e))
						})
					}
				)
			}
			const ni = new Set()
			let si
			function ri(e) {
				return (
					ni.add(e),
					si ||
						((si = () => {
							const e = { width: window.innerWidth, height: window.innerHeight },
								t = { target: window, size: e, contentSize: e }
							ni.forEach((e) => e(t))
						}),
						window.addEventListener("resize", si)),
					() => {
						;(ni.delete(e), !ni.size && si && (si = void 0))
					}
				)
			}
			const ai = 50,
				oi = { x: { length: "Width", position: "Left" }, y: { length: "Height", position: "Top" } }
			function li(e, t, i, n) {
				const s = i[t],
					{ length: r, position: a } = oi[t],
					o = s.current,
					l = i.time
				;((s.current = e["scroll" + a]),
					(s.scrollLength = e["scroll" + r] - e["client" + r]),
					(s.offset.length = 0),
					(s.offset[0] = 0),
					(s.offset[1] = s.scrollLength),
					(s.progress = it(0, s.scrollLength, s.current)))
				const d = n - l
				var c, u
				s.velocity = d > ai ? 0 : ((c = s.current - o), (u = d) ? c * (1e3 / u) : 0)
			}
			const di = {
					Enter: [
						[0, 1],
						[1, 1],
					],
					Exit: [
						[0, 0],
						[1, 0],
					],
					Any: [
						[1, 0],
						[0, 1],
					],
					All: [
						[0, 0],
						[1, 1],
					],
				},
				ci = { start: 0, center: 0.5, end: 1 }
			function ui(e, t, i = 0) {
				let n = 0
				if ((void 0 !== ci[e] && (e = ci[e]), Vt(e))) {
					const t = parseFloat(e)
					e.endsWith("px")
						? (n = t)
						: e.endsWith("%")
							? (e = t / 100)
							: e.endsWith("vw")
								? (n = (t / 100) * document.documentElement.clientWidth)
								: e.endsWith("vh")
									? (n = (t / 100) * document.documentElement.clientHeight)
									: (e = t)
				}
				return (Qe(e) && (n = t * e), i + n)
			}
			const pi = [0, 0]
			function hi(e, t, i, n) {
				let s = Array.isArray(e) ? e : pi,
					r = 0,
					a = 0
				return (
					Qe(e)
						? (s = [e, e])
						: Vt(e) && (s = (e = e.trim()).includes(" ") ? e.split(" ") : [e, ci[e] ? e : "0"]),
					(r = ui(s[0], i, n)),
					(a = ui(s[1], t)),
					r - a
				)
			}
			const fi = { x: 0, y: 0 }
			function vi(e, t, i) {
				let { offset: n = di.All } = i
				const { target: s = e, axis: r = "y" } = i,
					a = "y" === r ? "height" : "width",
					o =
						s !== e
							? (function (e, t) {
									let i = { x: 0, y: 0 },
										n = e
									for (; n && n !== t; )
										if (n instanceof HTMLElement)
											((i.x += n.offsetLeft), (i.y += n.offsetTop), (n = n.offsetParent))
										else if (n instanceof SVGGraphicsElement && "getBBox" in n) {
											const { top: e, left: t } = n.getBBox()
											for (i.x += t, i.y += e; n && "svg" !== n.tagName; ) n = n.parentNode
										}
									return i
								})(s, e)
							: fi,
					l =
						s === e
							? { width: e.scrollWidth, height: e.scrollHeight }
							: { width: s.clientWidth, height: s.clientHeight },
					d = { width: e.clientWidth, height: e.clientHeight }
				t[r].offset.length = 0
				let c = !t[r].interpolate
				const u = n.length
				for (let e = 0; e < u; e++) {
					const i = hi(n[e], d[a], l[a], o[r])
					;(c || i === t[r].interpolatorOffsets[e] || (c = !0), (t[r].offset[e] = i))
				}
				;(c &&
					((t[r].interpolate = ot(st(u), t[r].offset)),
					(t[r].interpolatorOffsets = [...t[r].offset])),
					(t[r].progress = t[r].interpolate(t[r].current)))
			}
			function mi(e, t, i, n = {}) {
				const s = n.axis || "y"
				return {
					measure: () =>
						(function (e, t = e, i) {
							if (((i.x.targetOffset = 0), (i.y.targetOffset = 0), t !== e)) {
								let n = t
								for (; n && n != e; )
									((i.x.targetOffset += n.offsetLeft),
										(i.y.targetOffset += n.offsetTop),
										(n = n.offsetParent))
							}
							;((i.x.targetLength = t === e ? t.scrollWidth : t.clientWidth),
								(i.y.targetLength = t === e ? t.scrollHeight : t.clientHeight),
								(i.x.containerLength = e.clientWidth),
								(i.y.containerLength = e.clientHeight))
						})(e, n.target, i),
					update: (t) => {
						;(!(function (e, t, i) {
							;(li(e, "x", t, i), li(e, "y", t, i), (t.time = i))
						})(e, i, t),
							(n.offset || n.target) && vi(e, i, n))
					},
					notify: Ge(t) ? () => t(i) : gi(t, i[s]),
				}
			}
			function gi(e, t) {
				return (
					e.pause(),
					e.forEachNative((e, { easing: t }) => {
						var i, n
						if (e.updateDuration) (t || (e.easing = Re), e.updateDuration(1))
						else {
							const s = { duration: 1e3 }
							;(t || (s.easing = "linear"),
								null === (n = null === (i = e.effect) || void 0 === i ? void 0 : i.updateTiming) ||
									void 0 === n ||
									n.call(i, s))
						}
					}),
					() => {
						e.currentTime = t.progress
					}
				)
			}
			const yi = new WeakMap(),
				bi = new WeakMap(),
				wi = new WeakMap(),
				Ci = (e) => (e === document.documentElement ? window : e)
			var Ti = i(272).gM,
				Si = i(272).LE
			;((Ti.Swiper = xe),
				(Ti.AnimateLoading = ke()),
				(Ti.Accordion = class {
					constructor(e, t = this.defaultOptions) {
						;(Le(this, "defaultOptions", {
							presetContentHeight: !1,
							duration: 300,
							onload: !1,
							callback: () => {},
						}),
							Le(this, "selectors", {
								items: [".m-accordion--item"],
								buttons: [".m-accordion--item-button "],
								contents: [".m-accordion--item-content"],
							}),
							Le(this, "openClass", "open"),
							Le(this, "initClass", "acc-initialized"),
							Le(this, "removeEvents", null),
							Le(this, "destroy", () => {
								;(this.removeEvents(),
									window.removeEventListener("resize", this.debouncedSetContentHeight))
							}),
							Le(this, "setContentOpacity", () => {
								this.domNodes.contents.forEach((e) => (e.style.opacity = 1))
							}),
							Le(this, "setItemOverflowState", () => {
								this.domNodes &&
									this.domNodes.items &&
									this.domNodes.items.forEach((e) => {
										let t = e.querySelector(".m-accordion--item-content")
										const i = e && e.classList.contains(this.openClass) ? "remove" : "add"
										t && t.classList[i]("m:overflow-hidden")
									})
							}),
							Le(this, "setContentHeight", () => {
								this.domNodes = queryDomNodes(this.selectors, this.container)
								const { items: e } = this.domNodes
								;(e.forEach((e) => {
									const t = e && e.querySelector(".m-accordion--item-content")
									let i = t && t.querySelectorAll("img")
									if (e && e.classList.contains(this.openClass)) {
										e.style.setProperty("--content-max-height", "auto")
										const n = t && t.scrollHeight
										;(e.style.setProperty("--content-max-height", `${n}px`),
											i &&
												i.length > 0 &&
												i.forEach((e) => {
													;(e.setAttribute("loading", "lazy"),
														e.setAttribute("width", e.width),
														e.setAttribute("height", e.height),
														-1 !=
															(-1 != e.src.indexOf("shopify.com") ||
																e.src.indexOf("myshopify.com")) &&
															-1 == e.src.indexOf("width=") &&
															e.setAttribute(
																"src",
																`${e.src.includes("?") ? `${e.src}&` : `${e.src}?`}width=${e.width + 100}`,
															))
												}))
									} else e && e.style.setProperty("--content-max-height", 0)
									if ((t && t.classList.add("max-height-set"), !t)) {
										const t = e.querySelector(".m-accordion--item-icon")
										t && t.classList.add("m:hidden")
									}
								}),
									this.setItemOverflowState(),
									this.setContentOpacity())
							}),
							Le(this, "toggle", (e) => {
								const t = this.domNodes && this.domNodes.items && this.domNodes.items[e],
									i = t && t.querySelector(".m-accordion--item-content"),
									n = t && t.classList.contains(this.openClass)
								let s = i && i.querySelectorAll("img")
								t && t.classList.toggle(this.openClass)
								const r = n ? 0 : i && i.scrollHeight
								;(i && t && t.style.setProperty("--content-max-height", `${r}px`),
									s &&
										s.length > 0 &&
										s.forEach((e) => {
											;(e.setAttribute("loading", "lazy"),
												e.setAttribute("width", e.width),
												e.setAttribute("height", e.height),
												-1 !=
													(-1 != e.src.indexOf("shopify.com") || e.src.indexOf("myshopify.com")) &&
													-1 == e.src.indexOf("width=") &&
													e.setAttribute(
														"src",
														`${e.src.includes("?") ? `${e.src}&` : `${e.src}?`}width=${e.width + 100}`,
													))
										}),
									n
										? (i && i.classList.add("m:overflow-hidden"),
											setTimeout(() => {
												i && i.style.removeProperty("opacity")
											}, 350))
										: (i && i.style.setProperty("opacity", "1"),
											setTimeout(() => {
												i && i.classList.remove("m:overflow-hidden")
											}, 350)))
							}),
							e &&
								!e.classList.contains(this.initClass) &&
								((this.container = e),
								(this.domNodes = queryDomNodes(this.selectors, this.container)),
								(this.options = Object.assign({}, this.defaultOptions, t)),
								(this.debouncedSetContentHeight = debounce(this.setContentHeight.bind(this), 300)),
								this.init()))
					}
					init() {
						;(this.container &&
							this.container.style.setProperty("--duration", ` ${this.options.duration}ms`),
							(this.removeEvents = addEventDelegate({
								context: this.container,
								selector: this.selectors.buttons[0],
								handler: (e, t) => {
									t.classList.add("m-according")
									const i = this.domNodes.buttons.indexOf(t)
									;(this.toggle(i),
										setTimeout(() => {
											t.classList.remove("m-according")
										}, 350))
								},
							})),
							this.options.presetContentHeight
								? this.options.onload
									? window.addEventListener("load", () => {
											window.requestAnimationFrame(this.setContentHeight)
										})
									: window.requestAnimationFrame(this.setContentHeight)
								: (this.setItemOverflowState(), this.setContentOpacity()),
							window.addEventListener("resize", this.debouncedSetContentHeight),
							"function" == typeof this.options.callback && this.options.callback(),
							this.container.classList.add(this.initClass))
					}
				}),
				(Si.Modal = De),
				(Si.scrollIntoView = Ne()),
				(Si.Notification = new (class {
					constructor() {
						;(Le(this, "noti", null),
							Le(this, "removeTimeoutId", null),
							Le(this, "hideTimeoutId", null),
							Le(this, "transitionDuration", 300),
							Le(
								this,
								"show",
								({
									target: e,
									type: t,
									message: i,
									method: n = "after",
									last: s = 3e3,
									delay: r = 0,
									debug: a = !1,
									sticky: o = !1,
								}) => {
									;(this.clearTimeout(),
										this.removeNoti(),
										setTimeout(() => {
											;((this.noti = _e($e, {
												type: t,
												message: i,
												onclick: this.handleClick,
												sticky: o,
											})),
												null == e || e[n](this.noti),
												requestAnimationFrame(() => this.noti.classList.add("show")),
												a ||
													(this.hideTimeoutId = setTimeout(() => {
														;(this.noti.classList.add("hide"),
															(this.removeTimeoutId = setTimeout(
																this.removeNoti,
																2 * this.transitionDuration,
															)))
													}, s)))
										}, r))
								},
							),
							Le(this, "handleClick", () => {
								;(clearTimeout(this.removeTimeoutId),
									this.noti.classList.add("hide"),
									setTimeout(this.removeNoti, 2 * this.transitionDuration))
							}),
							Le(this, "clearTimeout", () => {
								;(clearTimeout(this.removeTimeoutId), clearTimeout(this.hideTimeoutId))
							}),
							Le(this, "removeNoti", () => {
								var e
								null == this || null === (e = this.noti) || void 0 === e || e.remove()
							}))
					}
				})()),
				(Si.Motion = {
					inView: function (e, t, { root: i, margin: n, amount: s = "any" } = {}) {
						if ("undefined" == typeof IntersectionObserver) return () => {}
						const r = He(e),
							a = new WeakMap(),
							o = new IntersectionObserver(
								(e) => {
									e.forEach((e) => {
										const i = a.get(e.target)
										if (e.isIntersecting !== Boolean(i))
											if (e.isIntersecting) {
												const i = t(e)
												Ge(i) ? a.set(e.target, i) : o.unobserve(e.target)
											} else i && (i(e), a.delete(e.target))
									})
								},
								{ root: i, rootMargin: n, threshold: "number" == typeof s ? s : Fe[s] },
							)
						return (r.forEach((e) => o.observe(e)), () => o.disconnect())
					},
					animate: function (e, t, i) {
						return (Ge(e) ? Kt : Yt)(e, t, i)
					},
					scroll: function (e, t = {}) {
						var { container: i = document.documentElement } = t,
							n = Zt(t, ["container"])
						let s = wi.get(i)
						s || ((s = new Set()), wi.set(i, s))
						const r = mi(
							i,
							e,
							{
								time: 0,
								x: {
									current: 0,
									offset: [],
									progress: 0,
									scrollLength: 0,
									targetOffset: 0,
									targetLength: 0,
									containerLength: 0,
									velocity: 0,
								},
								y: {
									current: 0,
									offset: [],
									progress: 0,
									scrollLength: 0,
									targetOffset: 0,
									targetLength: 0,
									containerLength: 0,
									velocity: 0,
								},
							},
							n,
						)
						if ((s.add(r), !yi.has(i))) {
							const e = () => {
								const e = performance.now()
								for (const e of s) e.measure()
								for (const t of s) t.update(e)
								for (const e of s) e.notify()
							}
							yi.set(i, e)
							const t = Ci(i)
							;(window.addEventListener("resize", e, { passive: !0 }),
								i !== document.documentElement &&
									bi.set(i, ((o = e), Ge((a = i)) ? ri(a) : ii(a, o))),
								t.addEventListener("scroll", e, { passive: !0 }))
						}
						var a, o
						const l = yi.get(i),
							d = requestAnimationFrame(l)
						return () => {
							var t
							;("function" != typeof e && e.stop(), cancelAnimationFrame(d))
							const n = wi.get(i)
							if (!n) return
							if ((n.delete(r), n.size)) return
							const s = yi.get(i)
							;(yi.delete(i),
								s &&
									(Ci(i).removeEventListener("scroll", s),
									null === (t = bi.get(i)) || void 0 === t || t(),
									window.removeEventListener("resize", s)))
						}
					},
				}))
		})())
})()
